{
    "Api tokens": {
        "add token": "トークンを追加",
        "description": "TCTおよびConfigurator向けOEMファイルダウンロード用APIトークン、またはFOTA WEBサービスをリクエストする際にアプリケーションが使用するAPIトークンを生成します。APIドキュメントは<1>こちら</1>でご確認いただけます。",
        "example": "例：fota_token",
        "generate token": "トークンを生成する",
        "generated token": "生成されたトークン",
        "last used at": "最終使用日時",
        "name": "トークン名",
        "never": "なし",
        "no tokens": "利用可能なトークンはありません",
        "no tokens description": "トークンが追加されると、以下に一覧表示されます",
        "show token list": "トークン一覧を表示",
        "titles": {
            "Integration": {
                "description": "システム内でのFOTA WEB統合に利用されます",
                "name": "API統合トークン"
            },
            "Tct": {
                "description": "TCTおよびConfigurator向けOEMファイルダウンロードに使用",
                "name": "TCTトークン"
            }
        },
        "tokens": "APIトークン",
        "token type": "トークンタイプ",
        "token was created": "トークンが正常に作成されました"
    },
    "Attributes": {
        "Completed": "完了",
        "Count": "カウント",
        "Current": "現在の",
        "Date": "日付",
        "Empty": "空",
        "excluded files": "除外ファイル（samegrade）",
        "Failed": "失敗",
        "false": "",
        "Feature": "機能",
        "file size bytes": "ファイルサイズ（バイト）",
        "File_type": "ファイルタイプ",
        "File_version": "ファイルバージョン",
        "Fingerprint_id": "指紋認証",
        "Firmware_date": "ファームウェアの日付",
        "Firmware_version": "改訂版",
        "included files": "含まれるファイル",
        "Include_j1939": "",
        "Message": "メッセージ",
        "Metadata": "",
        "newest": "最新のものから",
        "oldest": "最も古いものから",
        "Order": "並び順",
        "Password_source": "",
        "Pending": "保留中",
        "Period": "期間",
        "Process_id": "",
        "Protocol_id": "プロトコルID",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "特定",
        "Start": "開始",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "BLEファームウェア",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "CANファームウェア",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "TAPPファームウェア"
        },
        "UserEntered": "",
        "vehicle": "車両",
        "Vehicle_id": "車両ID",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "認証アプリを確認してください",
            "check email": "メールを確認してください",
            "code required": "認証コードが必要です。",
            "code sent to email": "コードがメールに送信されました",
            "code valid": "コードは数分間有効です。",
            "enter code below": "以下のコードを入力してサインインしてください。",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "認証コードが必要です。認証アプリを確認し、以下のコードを入力してサインインしてください。",
        "check email": "受信トレイをご確認の上、受信したリンクをクリックしてパスワードをリセットしてください。",
        "community forum": "コミュニティサポートフォーラム",
        "contact us": "お問い合わせください",
        "create initial password": "パスワードを作成する",
        "create password": "パスワードを作成してください",
        "did not receive": "リンクが届きませんでしたか？",
        "do not have account": "まだアカウントをお持ちではありませんか？",
        "email": "メール",
        "enter email": "パスワード再設定の手順を受け取るには、登録済みメールアドレスを以下に入力してください。",
        "forgot password": "パスワードをお忘れですか？",
        "forgot your password": "パスワードをお忘れですか？",
        "for ms365": "Teltonika MS365ユーザー向け",
        "invalid email format": "無効なメールアドレス形式",
        "invalid password format": "パスワード形式が無効です",
        "link sent": "リンクが送信されました！",
        "length": "最低8文字",
        "lowercase": "少なくとも1つの小文字のアルファベットを含む",
        "new password": "新しいパスワード",
        "password": "パスワード",
        "passwords do not match": "パスワードが一致しません",
        "privacy policy": "FOTA WEBをご利用いただくことで、当社の<1>プライバシーポリシー</1>に同意したものとみなされます。",
        "remember password": "パスワードを覚えていますか？",
        "repeat password": "パスワードを再入力してください",
        "required": "必須",
        "resend": "再送信",
        "reset password": "パスワードのリセット",
        "send reset link": "リセットリンクを送信",
        "sign in": "サインイン",
        "sign in to fota": "FOTA WEBアカウントにサインインしてください",
        "signup": "サインアップ",
        "sso": "Microsoftでサインイン",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "大文字",
        "user consent text": "私はTeltonikaの<1>利用規約</1>および<2>データ処理契約</2>を理解し、これに同意します。",
        "welcome": "ようこそ",
        "wiki": "テレマティクスWikiナレッジベース"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Accept",
        "accept all": "すべてを受け入れる",
        "accept selected": "選択した項目を受け入れる",
        "actions": "アクション",
        "add": "追加",
        "add device": "デバイスを追加",
        "add more files": "ファイルを追加",
        "add new": "新規追加",
        "agree": "承知しました",
        "all companies": "すべての企業",
        "all of company": "{{companyName}}のすべて",
        "all rows selected": {
            "devices": "すべての {{count}} デバイスが選択されています",
            "tasks": "すべての {{count}} 件の保留中/実行中のタスクが選択されています",
            "groups": "すべての {{count}} グループが選択されています",
            "files": "{{count}}個のファイルがすべて選択されました",
            "companies": "{{count}}社すべてが選択されました",
            "users": "{{count}}人のユーザー全員が選択されています"
        },
        "approve": "承認",
        "assign": "割り当て",
        "assigning": "割り当て",
        "auto sync": "",
        "back": "戻る",
        "back to sign in": "サインインに戻る",
        "cancel": "キャンセル",
        "cancelling": "キャンセル",
        "cancel all tasks in group": "グループ内の全タスクをキャンセル",
        "cancel tasks": "タスクのキャンセル",
        "cannot create desktop licenses": "内部企業向けのライセンスは作成できません。",
        "cannot create offline licenses": "無制限ライセンスに対しては、オフラインライセンスを作成できません。",
        "change": "変更",
        "clear all": "すべてクリア",
        "clear all filters": "すべてのフィルターをクリア",
        "close": "閉じる",
        "company settings": "会社設定",
        "confirm": "確認",
        "continue": "続行",
        "copied": "コピーしました",
        "copy all": "",
        "copy to clipboard": "クリップボードにコピー",
        "create": "作成",
        "create role": "ロールを作成",
        "create task": "タスクを作成する",
        "creating": "作成中",
        "default view": "デフォルトビュー",
        "delete": "削除",
        "deleting": "削除",
        "deselect all": "すべて選択解除",
        "device": "デバイス",
        "disable": "無効化",
        "disagree": "私は同意しません",
        "discard": "破棄",
        "download": "",
        "edit": "編集",
        "enable": "有効化",
        "export": "エクスポート",
        "exporting": "エクスポート",
        "filters": "フィルター",
        "finish": "",
        "find tool": "ツールを探す",
        "first page": "最初のページ",
        "generate": "生成",
        "generate codes": "",
        "go back": "戻る",
        "import": "インポート",
        "importing": "インポート",
        "invite": "招待",
        "invite user": "ユーザーを招待する",
        "invite user to internal disabled": "内部企業へのユーザー招待は、管理者マネージャー以上のアクセス権限を持つユーザーのみが行えます。",
        "language": "言語",
        "last page": "最終ページ",
        "logout": "サインアウト",
        "maximize details": "詳細を最大化",
        "merge": "マージ",
        "merging": "マージ",
        "minimize details": "詳細を最小化",
        "more actions": "その他のアクション",
        "more filters": "追加フィルター",
        "more options": "その他のオプション",
        "move": "移動",
        "moving": "移動中",
        "next": "次へ",
        "next month": "来月",
        "next page": "次ページ",
        "no actions available": "利用可能なアクションはありません",
        "no permission": "「{{permissionName}}」権限が必要です。",
        "no permissions": "以下の権限が必要です：{{permissionNames}}。",
        "notify when done": "完了時に通知する",
        "number of selected companies": "{{companyCount}}社の{{companyName}}",
        "only essential": "必須機能のみ",
        "open fota web": "FOTA WEBを開く",
        "pages of": "{{total}}件",
        "previous month": "前月",
        "previous page": "前のページ",
        "print": "",
        "receive devices": "デバイスを受信する",
        "refresh page": "更新",
        "reject all": "すべて拒否",
        "reset to default": "デフォルトにリセット",
        "retry failed tasks": "失敗したタスクの再試行",
        "retrying": "再試行",
        "return home": "ホームに戻る",
        "revert manual level change": "手動レベル変更を元に戻す",
        "rows count per page": "1ページあたりの行数",
        "rows selected": "{{count}} 件選択済み",
        "save": "保存",
        "saving": "",
        "see all": "すべてを見る",
        "select all": {
            "devices": "{{count}}台のデバイスをすべて選択",
            "tasks": "保留中/実行中のタスク {{count}} 件をすべて選択",
            "groups": "{{count}} グループをすべて選択",
            "files": "{{count}} 個のファイルをすべて選択",
            "companies": "{{count}}社すべてを選択",
            "users": "{{count}}人のユーザーをすべて選択"
        },
        "select columns to show": "表示する列を選択",
        "selected page is first": "選択されたページは最初のページです",
        "selected page is last": "選択されたページは最後のページです",
        "select rows": "行を選択",
        "send code": "コードを送信",
        "settings": "設定",
        "show me": "表示",
        "show more": "さらに表示",
        "synchronize": "同期",
        "table statistics": "テーブル統計",
        "table view": "テーブルビュー",
        "transfer": "転送",
        "transferring": "転送",
        "transfer my devices": "デバイスを移行する",
        "undo": "元に戻す",
        "upload": "アップロード",
        "upload file": "新しいファイルをアップロード",
        "user": "ユーザー",
        "verify": "検証",
        "yes": "はい"
    },
    "Cookies": {
        "always active": "常時稼働",
        "analytics cookies": "アナリティクス・クッキー",
        "analytics cookies description": "これらのトラッカーは、ユーザーが当社ウェブサイトとどのようにやり取りしているかを理解するためのデータ収集を支援する分析に使用されます。これらの知見により、コンテンツの改善とユーザー体験を向上させる優れた機能の開発が可能になります。このカテゴリーのクッキーは無効化できます。",
        "cookie banner message": "当社および選定された第三者は、技術的な目的でクッキーまたは類似の技術を使用します。また、お客様の同意を得た上で、以下に明記するその他の目的にも使用します。",
        "cookie modal title": "クッキーを使用しています",
        "cookie policy": "クッキーポリシー",
        "essential cookies": "必須クッキー",
        "essential cookies description": "これらのトラッカーは、お客様が当社に依頼されたサービスの運営または提供に厳密に必要な活動に使用され、マーケティング目的で使用される可能性のあるお客様に関する情報を収集せず、インターネット上の閲覧履歴を記憶しません。このカテゴリーのクッキーは無効化できません。"
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "リモートデバイス更新の必須機能",
                "Standard": "高度な自動化と統合",
                "Premium": "エンタープライズ規模での拡張性とアップデートへの早期アクセス"
            },
            "resource limit types": {
                "Companies": "企業",
                "Users": "ユーザー",
                "ConfigurationFiles": "設定ファイル"
            }
        },
        "empty state": {
            "description": {
                "configurations": "FOTA WEBが設定を検出するとすぐに、こちらでリストを確認できるようになります。",
                "firmware versions": "FOTA WEBがファームウェアバージョンを検出すると、すぐにここでリストを確認できます。"
            },
            "title": {
                "configurations": "設定は検出されませんでした",
                "firmware versions": "検出されたファームウェアバージョンはありません",
                "news": "表示するニュースはありません"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "本日",
                "7": "7日間",
                "30": "30日間",
                "90": "90日間"
            },
            "period": "期間"
        },
        "new": "",
        "news": {
            "body": {
                "1": "2025年1月7日以降にご招待いただいたユーザーについては、アカウント有効化と同時に二段階認証（2FA）が必須となりますのでご注意ください。二段階認証はメール認証または認証アプリを通じてご利用いただけます。",
                "2": "FOTA WEBの定期メンテナンスを2025年6月3日 05:00 UTCより実施いたします。メンテナンス中はユーザーインターフェース、APIアクセス、タスク実行、OBDサービス、CANサービスを含む全サービスが利用不可となりますのでご注意ください。サービス停止時間は約1時間を見込んでおります。",
                "3": "<section><p>FOTA WEB のデバイスアンロック機能に重要な改良が加えられたことをお知らせいたします。</p></section> <section><p>すべてのユーザーロールが、ヘルプデスク経由でテクニカルサポートに連絡することなく、デバイスを直接アンロックできるようになりました。</p> <p>主な詳細：</p> <ul><li>ユーザーは、24 時間以内に同じデバイスを 3 回までアンロックできます。</li> <li>制限に達すると、アンロックオプションは24時間一時的に無効になります。</li> <li>アンロック制限を超過した場合、エラーメッセージが表示されます。この更新により待機時間が大幅に短縮され、フリート管理の制御性が向上します。</li></ul></section> <section><a>機能の使用方法を確認する</a></section>",
                "4": "<section><h3>新デバイス統計</h3> <p>2つの新ウィジェットでデバイス活動の詳細な分析が可能に：</p> <p><strong>アクティベート済みデバイス</strong>: この新統計では、さまざまな期間（本日、7日間、30日間、90日間）にアクティベート（接続）されたデバイスの数が表示されます。</p> <p><strong>インポート済みデバイス</strong>：同様に、新しい「インポート済みデバイス」統計では、本日、7日間、30日間、90日間にインポートされたデバイスの数が追跡されます。</p> </section> <section><h3>タスクウィジェットのご紹介</h3> <p>まったく新しいタスクウィジェットで業務状況を追跡しましょう：</p> <p><strong>キュー入りタスク</strong>：現在保留中のタスク数を明確に確認できます。</p> <p><strong>タスク概要</strong>：期間（7 日、30 日、90 日）およびステータスごとにタスクの分布を詳細に把握できます。これには、完了、エラーありで完了、失敗したタスクが含まれます。</p></section> <section><h3>よりスマートなファームウェアおよび設定の概要</h3> <p>ファームウェアバージョンおよび設定ウィジェットを改良しました。</p> <ul><li>データをより明確にするため、「不明」の統計情報を削除しました。</li> <li>ファームウェアおよび設定名とその数をより明確に表示するようになりました。</li> <li>最初に上位 5 つのバージョンまたは構成が表示され、「さらに表示」オプションで最大 100 件の異なるエントリを表示できます。</li> <li>特定のファームウェアまたは構成にカーソルを合わせてクリックすると、「デバイスページ」に移動し、フィルタが適用されます。</li></ul></section> <section><h3>ニュースウィジェットの機能強化</h3> <p>一目で最新情報を把握！ニュースウィジェットが新しく生まれ変わりました。ニュース項目をクリックすると、詳細情報を読むことができるようになりました。</p></section> <section><h3>デバイスステータスの改善</h3> <p>デバイスステータスウィジェットが視覚的に更新され、より明確になりました。 さらに、デバイスのステータスにカーソルを合わせてクリックすると、「デバイス」ページで対応するステータスのデバイスをフィルタリングできるようになりました。</p></section> <section><p>これらの更新により、日々の作業がさらに容易になり、より有益な情報が得られることを願っています。ご意見をお聞かせください！</p></section>",
                "5": "<section><h3>API変更計画</h3></section> <section><p><strong>2025年9月24日</strong>に、ユーザーエンティティを返すレスポンス（例：GET /users または GET /users/{userId} エンドポイント）から「role」フィールドを削除します。この変更は、FOTA WEBにおけるより堅牢で柔軟な権限システムへの道筋をつけるために行われます。</p></section> <section><h3>新機能の予告：ロールと権限</h3></section> <section><p>現行のロールシステムでは必要な柔軟性が得られないことを認識しています。開発チームは現在、権限を細かく制御できるロールを作成可能な新機能「<strong>ロールと権限管理</strong>」の開発に注力中です。</p></section> <section><p>この新システムでは、ユーザーに固定ロールを割り当てたり、特定のニーズに合わせて権限を調整したり、カスタムロールを作成したりできます。私たちはこの機能に非常に期待しており、ロールと権限管理の詳細が利用可能になり次第、さらに詳しくお伝えできることを楽しみにしています。</p></section>",
                "6": "<section><p>FOTA WEB内でのユーザーアクセスを精密に制御する新機能「<strong>ロールと権限</strong>」の提供を開始いたします。本機能では、特定の<strong>権限</strong>（例：「タスク作成」、「ユーザー招待」）の集合である<strong>ロール</strong>を用いてユーザー権限を定義できます。 基本セキュリティとして変更不可の<strong>静的ロール</strong>（管理者、ユーザー、ゲスト）に加え、<strong>プレミアム企業レベル</strong>のユーザーのみが作成・編集可能なカスタマイズ可能な<strong>カスタムロール</strong>を備えています。権限はデバイス、タスク、ユーザーなどの主要領域ごとに分類され、管理セクションの「権限数」にカーソルを合わせると確認できます。 <strong>この更新前に作成された既存のユーザーはすべて、「管理者」ロールが自動的に割り当てられており、これまで実行できたすべてのアクションを引き続き実行できます。</strong></p></section> <section><p>この更新により、セキュリティと作業負荷の分散が強化されます。 ロールは会社ごとに固有のものとなり、会社構造間で継承されることはありません。ユーザーを会社に招待または移動する際には必ずロールを割り当てる必要があり、アクティブなユーザー割り当てがあるロールは削除できないことにご注意ください。<strong>ユーザー</strong>ページで<strong>新しい「ロール」フィルター</strong>を使用できるようになり、管理が容易になりました。組織のニーズに合わせたアクセス権を設定するため、今すぐ「ロールと権限」セクションをご覧ください。</p></section> <section><p>ユーザーとロールの管理に関する詳細なガイドは、<a>Wikiページ</a>をご覧ください。</p></section>",
                "7": "<section><p>時間厳守の作業をより正確に管理できる、強力な新機能「<strong>日付によるスケジュール設定</strong>」の提供を開始いたします。</p></section> <section><h3>主な特徴</h3></section> <section><ul><li><strong>特定の期限</strong> - 新しい「日付によるスケジュール設定」オプションを使用して、<strong>特定の日付または日付範囲</strong> にタスクをスケジュール設定できるようになりました。</li> <li><strong>従来の動作は変更なし</strong> - 慣れ親しんだ<strong>時間によるスケジュール設定</strong>機能は引き続き完全に利用可能です。</li> <li><strong>期限切れステータス</strong> - 設定された日までに完了しなかったタスクは、自動的に<strong>期限切れ</strong>ステータスに変更され、<strong>「設定されたスケジュール中にタスクは完了しませんでした」というメッセージが表示されます。</strong></li> <li><strong>ユーザー中心のタイミング</strong> - すべてのスケジュールは、<strong>ユーザーのローカル時間</strong> に基づいて作成されます。</li></ul></section> <section><h3>仕組み</h3></section> <section><p>タスクの <strong>「日付によるスケジュール」</strong> を設定する場合：</p> <ul><li>日付ピッカーコンポーネントで<strong>「開始日」</strong>と<strong>「終了日」</strong>を選択します。</li> <li>日付ピッカーは、会社レベルのタスク有効期限を遵守します。</li></ul></section><section><p><strong>日付によるスケジュール設定</strong>機能は現在、上位の会社レベル限定であり、<strong>ベーシック</strong>プランでは利用できません。</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "2025年1月7日より新規ユーザーへの2段階認証（2FA）の必須化",
                "2": "2025年6月3日に計画メンテナンスを実施",
                "3": "新機能アップデート：全ユーザー向けデバイスロック解除の簡素化",
                "4": "ダッシュボードで新着情報をチェック！",
                "5": "重要：今後のAPI変更と、ロールと権限に関する先行情報",
                "6": "新機能リリース：「ロールと権限」による強化された制御機能",
                "7": "新機能：日付によるタスクスケジュールの柔軟性向上",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "公開日",
        "take me there": "こちらへ",
        "tasks": {
            "current": "現在の",
            "status": {
                "completed": "完了",
                "completed_with_errors": "エラーを伴って完了しました",
                "failed": "失敗",
                "no tasks": "タスクなし"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7日間",
                "tooltipTitle": "過去7日間"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30日間",
                "tooltipTitle": "過去30日間"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90日間",
                "tooltipTitle": "過去90日間"
            }
        },
        "title": {
            "activated": "アクティベートされたデバイス",
            "configurations": "設定",
            "device status": "デバイスステータス",
            "firmware versions": "ファームウェアのバージョン",
            "imported": "インポートされたデバイス",
            "news": "ニュース",
            "queued tasks": "待機中のタスク",
            "refreshed every hour": "1時間ごとに更新されます",
            "resource limits": "リソース制限",
            "task overview": "タスク概要",
            "tasks": "タスク"
        },
        "tooltips": {
            "activated": "選択期間（本日、過去7日間、過去30日間、過去90日間）にFOTA WEBへ初めて接続したデバイスの数。",
            "configurations": "デバイスにアップロードされた設定ファイル名の分布を表示します。最大100個の固有ファイル名が表示されます。",
            "firmware versions": "接続デバイスから報告されたファームウェアバージョンの分布を表示します。最大100種類の固有バージョンが表示されます。",
            "imported": "選択した期間（本日、過去7日間、過去30日間、過去90日間）にアカウントに追加されたデバイスの数。"
        }
    },
    "Date picker": {
        "disableFuture": "未来の日付は選択できません",
        "disablePast": "過去の日付は選択できません",
        "invalidDate": "無効な日付",
        "maxDate": "最大日付",
        "minDate": "最小日付",
        "shouldDisableDate": "この日付は選択できません",
        "shouldDisableMonth": "この月は選択できません",
        "shouldDisableYear": "この年は選択できません"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "新しいデバイスを追加",
        "add new device description": "選択した会社およびグループに、単一または複数の新規デバイスを追加します。FMやFMAなどのレガシーデバイスのみを「レガシーデバイスとしてインポート」チェックボックスをオンにしてインポートする必要があります。",
        "add new device legacy title": "レガシーデバイスとしてインポート。",
        "add new device legacy description": "「作成日時」を2016.01.01に設定し、「モデル」をレガシーに設定してください。",
        "add new product code": "新規製品コードを追加",
        "add new product code description": "新しいデバイス製品コードを追加し、利用可能なCANパッケージにリンクします。",
        "all permissions": "すべての権限",
        "assign access group": "",
        "assign can package description": "パッケージタイプを選択し、選択した全デバイスに割り当てます。",
        "assign role": "役割を割り当てる",
        "attribute value": "属性の値",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "ダウンロード開始",
        "by date": "日付順",
        "by time": "時間順",
        "can adapter": "CANアダプター",
        "cancel pending tasks": "同じタスクタイプの保留中のタスクをキャンセルする",
        "cancel tasks": "タスクのキャンセル",
        "cancel tasks in group": {
            "alert title": "この操作は完了までに最大数分かかる場合があります。",
            "banner description": "タスクの更新状況を確認するには、タスクグループの詳細を参照するか、ページを更新してください。",
            "banner title": "この操作は、タスクの数に応じて完了までに最大数分かかる場合があります。",
            "description": "「承諾」をクリックすると、保留中および実行中のタスクがすべてキャンセルされます。続行してもよろしいですか？",
            "title": "グループ内のすべてのタスクをキャンセルしますか？"
        },
        "canObd": "CAN/OBD",
        "carrier": "通信キャリア",
        "clear device history banner": "",
        "client email": "クライアント担当者メールアドレス",
        "companies": "企業",
        "company": "会社",
        "company level": {
            "Basic": "基本",
            "Internal": "内部向け",
            "Premium": "プレミアム",
            "Standard": "標準"
        },
        "company level change description": "会社レベルをアップグレードするには、新しいレベルを選択し、その理由を説明してください。会社レベルのダウングレードはできません。すべての日付はUTCで表示されます。",
        "company level manual revert": {
            "confirmation": {
                "description": "この操作により、会社レベルが自動的に割り当てられたレベル「{{companyLevel}}」にリセットされます。続行してもよろしいですか？",
                "title": "手動レベル変更を元に戻す？"
            },
            "description": "元に戻すと、会社レベルが自動的に割り当てられたレベルに戻ります。",
            "title": "この会社レベルは{{expirationDate}}まで手動でアップグレードされていました。"
        },
        "company level type": "企業レベルタイプ",
        "company name": "会社名",
        "company statistics": {
            "child companies": "子会社の数",
            "devices": "デバイス数",
            "files": "ファイル数",
            "groups": "デバイスグループ数",
            "tasks": "タスク数",
            "users": "ユーザー数"
        },
        "company type": {
            "All": "",
            "Client": "クライアント",
            "Internal": "内部向け",
            "Virtual": "仮想"
        },
        "configuration": "設定",
        "confirmations": {
            "are you sure": "本当によろしいですか？",
            "are you sure you wish to continue": "続行してもよろしいですか？",
            "assign can package confirmation": "選択したパッケージを指定された台数のデバイスに割り当てることを確認しますか？",
            "cancel task confirmation": {
                "first part": "指定された数のタスクを本当にキャンセルしますか？",
                "second part": "該当する場合、影響を受けるタスクの数を入力し、「確認」をクリックしてください。"
            },
            "create task confirmation": "指定された台数のデバイスに対してタスクを作成してもよろしいですか？",
            "delete resource confirmation": {
                "first part": "指定された数の{{resource}}を削除してもよろしいですか？",
                "second part": "該当する{{resource}}の数を入力し、「削除」をクリックしてください。"
            },
            "delete resources": {
                "companies": "企業",
                "files": "ファイル",
                "groups": "デバイスグループ",
                "deviceModels": "モデル",
                "productCodes": "製品コード",
                "roles": "役割",
                "users": "ユーザー"
            },
            "description second part": "該当する場合は、影響を受けるデバイスの数を入力し、「確認」をクリックしてください。",
            "export device data confirmation": "指定された台数のデバイスについて、デバイスデータをエクスポートしてもよろしいですか？",
            "file": "ファイル内に存在する行数を入力してください",
            "filter": {
                "companies": "フィルタリングされた企業数を入力してください",
                "devices": "フィルタリングされたデバイスの数を入力してください",
                "files": "フィルタリングされたファイルの数を入力してください",
                "groups": "フィルタリングされたデバイスグループの数を入力してください",
                "productCodes": "フィルタリングされた製品コードの数を入力してください",
                "tasks": "フィルタリングされたタスクの数を入力してください",
                "users": "フィルタリングされたユーザー数を入力してください"
            },
            "id_list": {
                "companies": "選択した企業数を入力してください",
                "devices": "選択したデバイスの数を入力してください",
                "files": "選択したファイルの数を入力してください",
                "groups": "選択したデバイスグループの数を入力してください",
                "productCodes": "選択した製品コードの数を入力してください",
                "tasks": "選択したタスクの数を入力してください",
                "users": "選択したユーザー数を入力してください"
            },
            "merge companies confirmation": "{{sourceCompany}}社と{{targetCompany}}社の合併が間もなく行われます。",
            "move companies confirmation": "{{sourceCompany}}社から{{targetCompany}}社への移行が間もなく行われます。",
            "move devices confirmation": "指定された数のデバイスを別の会社へ移動してもよろしいですか？",
            "number of lines": "行数",
            "selected 20 or more devices": "20台以上のデバイスを選択しました..",
            "transfer devices confirmation": "指定された数のデバイスを別の会社に移行してもよろしいですか？"
        },
        "confirm cannot revert": "この操作は元に戻せません。",
        "confirm merge companies": "これらの会社を本当に合併しますか？",
        "count": "件数",
        "create company": "会社を作成",
        "create company description": "選択した親会社の下に新しい会社を作成する。",
        "create desktop license": "Desktopライセンスを作成する",
        "create desktop license description": "クライアント企業向けに、そのIPアドレス、ハードウェアキー、有効期限（最大2年）を指定した新しいオンラインFOTA Desktopライセンスを発行する。",
        "create group": "グループを作成",
        "create group description": "デバイスをグループ化して管理を簡素化し、一括割り当てを可能にします。",
        "create model": "モデルを作成",
        "create model description": "新しいデバイスモデルを作成し、名前、プラットフォーム、およびTCT webサポートを指定します。",
        "create offline license": "オフラインライセンスを作成",
        "create or edit group description": "ファームウェアと設定をグループに割り当て可能。割り当て後、グループメンバー（デバイス）全員に対してファームウェアおよび／または設定更新タスクが生成される。",
        "create role": "ロールを作成",
        "create role description": "新しいロールを作成するには、名前と説明を指定し、会社を選択し、特定の権限を割り当てます。",
        "create smart group": "スマートグループを作成",
        "create smart group banner message": "",
        "create smart group description": "各プラットフォームごとに、グループに対してファームウェアおよび設定ファイルを割り当て可能です。ファイルが割り当てられると、グループ内の全デバイス向けに更新タスクが生成されます。",
        "create task description first step": "設定やファームウェアの更新から、選択またはフィルタリングされたデバイスからのログ受信、設定取得など、多様なタスクを作成可能。さらに、作成したタスクをスケジュール設定でき、利便性を高めます。",
        "create task description last step": "タスク作成前に、以下の情報が正しいことを確認してください。",
        "current level": "現在のレベル",
        "custom resource limits": {
            "at least one limit must be higher": "少なくとも1つの制限値は、デフォルトのプレミアムレベル値よりも高く設定する必要があります。",
            "configuration files per device": "デバイスごとの設定ファイル",
            "confirmation modal description": "会社「{{companyName}}」の以下のリソース制限を変更してもよろしいですか？",
            "confirmation modal title": "会社のリソース制限を変更しますか？",
            "count": {
                "companies count": "企業数：{{number}}",
                "configuration files per device count": "デバイスごとの設定ファイル数: {{number}}",
                "tasks per group count": "グループごとのタスク数: {{number}}",
                "users count": "ユーザー数: {{number}}"
            },
            "explanations": {
                "companies": "企業階層内で作成可能な子会社の総数。",
                "configuration files per device": "保存可能な設定ファイルの数（1デバイス＝1設定ファイル）。各企業レベルで保証される設定ファイルの最小数は100です。",
                "tasks per group": "1つのタスクグループに含められるタスクの数。",
                "users": "企業階層内で作成可能なユーザー総数。"
            },
            "main modal description": "企業、ユーザー、タスクグループごとのタスク、設定ファイルなど、異なるリソースタイプごとにカスタムリソース量を設定可能。カスタムリソースはプレミアムレベルの有効期限切れまたは手動リセットまで有効です。",
            "resources limit type": "リソース制限タイプ",
            "revert custom resource limits": "カスタムリソース制限を元に戻す",
            "revert custom resource limits description": "すべての制限をリセットすると、デフォルトのリソース値に設定され、会社レベルがプレミアムに変更されます。",
            "revert custom resource limits description confirmation": "この操作により、リソース制限が「プレミアム」レベル向けに自動割り当てされた値に戻ります。続行しますか？",
            "revert custom resource limits title": "この会社ではリソース制限が手動で設定されました。",
            "revert custom resource limits title confirmation": "カスタムリソース制限を元に戻す？",
            "tasks per group": "グループごとのタスク"
        },
        "date range": "日付範囲",
        "date to": "終了日",
        "delete companies": "企業を削除する",
        "delete deviceModels": "モデルを削除",
        "delete files": "ファイルを削除する",
        "delete file warning": "ファイルの削除は関連するタスクおよびタスクグループをキャンセルします。",
        "delete groups": "デバイスグループを削除",
        "delete productCodes": "製品コードを削除する",
        "delete roles": "ロールを削除",
        "delete tasks and history": "",
        "delete users": "ユーザーを削除する",
        "description": "説明",
        "desktop license delete description": "Desktopライセンス「{{name}}」を削除してもよろしいですか？",
        "desktop license name": "Desktopライセンス名",
        "device identifier": "デバイス識別子",
        "device transfer": {
            "main": {
                "description": "選択またはフィルタリングされたデバイスを、受信企業が発行したトークンを使用して、関連のない企業へ転送する。",
                "title": "デバイス転送"
            },
            "receive devices": {
                "copy token": "生成されたトークンをコピーし、自社から貴社へデバイスを移管する担当者に送信してください。",
                "description": "受信デバイストークンを作成し、転送会社に送信する。",
                "token info": "このトークンは1回限りの使用であり、21日後に失効します。"
            },
            "transfer devices": {
                "confirmation": "以下の会社へデバイスを移管してもよろしいですか？",
                "device token": "デバイス転送トークンは、デバイスを転送したい先の会社の管理者から取得する必要があります。",
                "transfer from file": "自社から、先ほど入力したトークンを持つ企業へ転送したいデバイス一覧（IMEI）を含むファイルをアップロードしてください。"
            }
        },
        "device transfer token": "デバイス転送トークン",
        "downgrading company level is not possible": "企業レベルのダウングレードはできません",
        "download sample file message": "必要なフォーマットの例を確認するには、<1>サンプルCSVテンプレート</1>をダウンロードしてください。",
        "edit group banner message": "ファームウェアおよび／または設定ファイルの変更は、同一タイプのすべての待機中のタスクをキャンセルします。",
        "edit group description": "このデバイスグループの設定を変更します。",
        "edit role description": "ロール名、説明、権限をカスタマイズ可能。割り当てられた会社は変更できません。",
        "edit smart group description": "各プラットフォームごとに、グループに対してファームウェアや設定ファイルを割り当てたり変更したりできます。ファイルが割り当てられたり変更されたりすると、グループ内の全デバイスに対して更新タスクが生成されます。",
        "email": "メール",
        "enter": "入力",
        "enter code": "コードを入力",
        "enter description": "説明を入力",
        "enter name": "名前を入力",
        "example": "例",
        "expires at": "有効期限：",
        "explanation": "説明",
        "export device data": "デバイスデータのエクスポート",
        "export device description": "",
        "export file format": "エクスポートファイル形式",
        "feature": "機能",
        "feature control": "機能制御",
        "field disabled until company selected": "会社を選択するまで、このフィールドは無効です。",
        "firmware": "ファームウェア",
        "files to download": "ダウンロードするファイル",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "アップロードされた1-Wire認証リストは自動的にソートされ、機能の速度と精度が向上します。",
                "bluetooth_authorization_list": "アップロードされたBluetooth認証リストは自動的にソートされ、機能の速度と精度が向上します。"
            },
            "endings": {
                "file": "ファイル",
                "files": "ファイル"
            },
            "fail": {
                "multiple": "{{failCount}} 個の {{fileEnding}} ファイルが、エラーのため {{totalCount}} 個中アップロードされませんでした。",
                "single": "{{failCount}} 件中 {{totalCount}} 件の {{fileEnding}} がエラーによりアップロードされませんでした。"
            },
            "success": {
                "multiple": "すべてのファイルが選択された企業に正常に追加されました。",
                "single": "すべてのファイルが選択された企業に正常に追加されました。"
            }
        },
        "filtered": "フィルタリング済み",
        "filtered companies": "フィルタリングされた企業",
        "filtered devices": "フィルタリングされたデバイス",
        "filtered files": "フィルタリングされたファイル",
        "filtered groups": "フィルタリングされたグループ",
        "filtered tasks": "フィルタリングされたタスク",
        "filtered users": "フィルタリングされたユーザー",
        "find tool": {
            "device": {
                "error not valid": "IMEIは15文字で構成されている必要があります",
                "error subtitle": "デバイスが見つかりません。別のIMEIを入力してください。",
                "error title": "デバイスが見つかりません",
                "link": "デバイスへ移動",
                "no permission": "このデバイスを表示する権限がありません。"
            },
            "user": {
                "error not valid": "無効なメールアドレス形式",
                "error subtitle": "ユーザーが見つかりません。別のユーザーメールアドレスを入力してください。",
                "error title": "ユーザーが見つかりません",
                "link": "ユーザーへ移動",
                "no permission": "このユーザーを表示する権限がありません。"
            }
        },
        "firmware date": "ファームウェアの日付",
        "from form": "フォームから",
        "from file": "ファイルから",
        "general": "一般",
        "gsm_number": "GSM番号",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "IMEI制限",
        "import device data": "デバイスデータのインポート",
        "import device data description": "提供されたリスト内のデバイスについて、選択された属性データをインポートする。",
        "import device data info": "各属性には括弧内に最大文字数が表示されます。属性の文字数が最大文字数を超えた場合、自動的に最大文字数まで短縮されます。",
        "import device data limit": "(最大 {{limit}} 文字)",
        "imsi": "IMSI",
        "input text too long": "テキストが長すぎます。最大{{maxLength}}文字まで許可されています。",
        "invalid hardware key": "無効なハードウェアキー形式",
        "invalid imei": "IMEIが無効です",
        "invalid ipv4": "無効なIPv4形式",
        "invalid serial": "無効なシリアル番号",
        "invalid value": "無効な値",
        "inverted selection": "逆選択",
        "invite user": "ユーザーを招待する",
        "invite user description": "選択した親会社に新規ユーザーを招待し、その役割を設定します。送信後、ユーザーは招待が失効するまでの30日間以内に招待を受け入れる必要があります。",
        "invite user max roles": "最大5つのロールまで許可されます。続行するにはいずれか1つを選択解除してください。",
        "log files": "ログファイル",
        "make": "作成",
        "manage permissions": "アカウントおよびサイトレベルの全データを管理します。",
        "maximum value is": "最大値は {{value}} です",
        "merge companies": "企業統合",
        "merge companies info": "すべてのソース会社のリソース（デバイス、グループ、ファイル、会社、ユーザーとその役割）はターゲット会社へ移行されます。統合前にユーザー役割の確認をお勧めします。移行後、ソース会社は削除されます。",
        "merge companies disabled option": {
            "client to internal": "クライアントタイプの会社は、内部タイプの会社と合併できません。",
            "internal": "内部タイプの会社は合併できません。",
            "lz code": "Company with Codeはマージできません。"
        },
        "minimum value is": "最小値は {{value}} です",
        "move companies disabled option": {
            "internal": "内部型企業は移転不可。"
        },
        "move device": "デバイスを移動する",
        "move device description": "選択またはフィルタリングされたデバイスを、企業階層内の既存の会社および／またはグループに移動します。",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "デバイスの移動",
        "name": "名称",
        "newest": "新しい順",
        "no dropdown files": {
            "description": "このオプションを選択するには、新しい$t(Dialog##no dropdown files##file names##{{fileName}})ファイルをアップロードしてください。",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "1-Wire認証リスト",
                "adas_firmware": "ADASファームウェア",
                "ble_fw": "BLEファームウェア",
                "blue_nrg": "BlueNrgファームウェア",
                "bluetooth_authorization_list": "Bluetooth認証リスト",
                "can_chip_firmware": "FM CANチップファームウェア",
                "carrier_advance_firmware": "Carrier Advanceファームウェア",
                "carrier_advance_settings": "Carrier Advance設定",
                "carrier_apx_firmware": "Carrier APXファームウェア",
                "carrier_apx_settings": "Carrier APX設定",
                "certificate": "TLS証明書",
                "configuration": "設定",
                "dsm_firmware": "DSMファームウェア",
                "dtb": "DTB",
                "firmware": "ファームウェア",
                "fw_bundle": "ファームウェアバンドル",
                "gnssm_download_assistant": "GNSS-M ダウンロード アシスタント",
                "gnssm_firmware": "GNSS-Mファームウェア",
                "main configuration": "",
                "manual_geofence_list": "手動ジオフェンスシナリオ一覧",
                "meig_modem_firmware": "MeiG モデムファームウェア",
                "netprisma_modem_firmware": "NETPRISMA モデムファームウェア",
                "psub": "サブスクリプション",
                "quectel_modem_firmware": "クエックテル モデム ファームウェア",
                "simcom_modem_firmware": ""
            },
            "main": "$t(Dialog##no dropdown files##file names##{{fileName}}) ファイルは存在しません。"
        },
        "none": "なし",
        "obd oem": "OBD OEM",
        "offline license delete description": "オフラインライセンス「{{name}}」を削除してもよろしいですか？",
        "oldest": "古い順",
        "only integers": "有効な数値は整数のみです",
        "only numbers": "数字のみ入力できます",
        "optional": "オプション",
        "other companies": "他社",
        "parent company": "親会社",
        "permission preset": "権限プリセット",
        "platform compatibility": {
            "banner text": "選択されたデバイスモデルの一部は、選択されたタスクタイプと互換性がありません。互換性のないデバイスモデルに対しては、このタスクタイプはデフォルトでは作成されません。",
            "compatible model devices": "対応デバイスモデル",
            "count text": "{{totalCount}}台のデバイス中、<1>{{compatibleCount}}</1>台に対してタスクが作成されます。",
            "create tasks for incompatible devices": "互換性のないデバイス向けにタスクを作成する。",
            "devices from file": "デバイスからのファイル",
            "platform": "{{title}}プラットフォーム",
            "task applies": "タスクが適用される対象",
            "task cannot be created": "互換性のないモデルデバイスに対してはタスクを作成できません。"
        },
        "receiving company": "この会社はお客様のデバイスを受け取ります",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "この操作は完了までに最大数分かかる場合があります。",
            "banner description": "タスクの更新状況を確認するには、タスクグループの詳細を参照するか、ページを更新してください。",
            "description": "「承諾」を押すと、失敗したタスクをすべて再試行します。続行してもよろしいですか？",
            "title": "グループ内の全タスクを再試行しますか？"
        },
        "revision": "改訂版",
        "revision value error": "値は2桁（00～99）でなければなりません。",
        "role name": "ロール名",
        "root company": "親会社",
        "sales email": "営業マネージャー宛メール",
        "scheduled time warning": "スケジュールされたタスクは、デバイスのFOTA接続時間設定を変更しません。選択した時間枠内でデバイスがFOTAに接続した場合にタスクが実行されます。デバイスが選択した時間枠以上の間隔でFOTA WEBに接続するよう設定されていることを確認してください。",
        "schedule task": "スケジュールタスク",
        "select": "選択",
        "select at least one": {
            "companies": "少なくとも1社を選択してください",
            "devices": "少なくとも1つのデバイスを選択してください",
            "files": "少なくとも1つのファイルを選択してください",
            "groups": "少なくとも1つのグループを選択してください",
            "tasks": "少なくとも1つのタスクを選択してください",
            "users": "少なくとも1人のユーザーを選択してください"
        },
        "selected": "選択済み",
        "selected companies": "選択企業",
        "selected deviceModels": "選択されたモデル",
        "selected devices": "選択されたデバイス",
        "selected files": "選択済みファイル",
        "selected groups": "選択されたデバイスグループ",
        "selected productCodes": "選択された製品コード",
        "selected roles": "選択された役割",
        "selected tasks": "選択されたタスク",
        "selected users": "選択されたユーザー",
        "select company": "",
        "select group": "",
        "select time interval": "時間間隔を選択",
        "selected time window": "選択した時間枠：{{fromDate}} から {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "{{platformName}}プラットフォームのデバイス向けに利用可能なファイルを選択してください。",
            "title": "{{platformName}} プラットフォーム ファイル"
        },
        "sn": "シリアル番号",
        "specific": "特定",
        "time period": "期間",
        "time period custom": "カスタム",
        "tls certificate transfer info": "",
        "token has expired": "トークンが期限切れになりました",
        "token is valid": "トークンは有効です",
        "transfer companies": "転送会社",
        "transfer companies description": "2つの会社を移動するか統合するかを選択してください。一部の操作は元に戻せません。",
        "transfer devices": "デバイス転送",
        "tri source": {
            "selected tab description": {
                "create task": "チェックボックスを使用して選択されたデバイスに対して、指定されたタスクが作成されます。",
                "general": "チェックボックスで選択されたデバイスに対して、選択されたアクションが実行されます。"
            },
            "filtered tab description": {
                "create task": "選択されたタスクは、利用可能なフィルターを一つ以上使用してフィルタリングされたデバイスに対して作成されます。",
                "general": "選択されたアクションは、利用可能な1つ以上のフィルターを使用してフィルタリングされたデバイスに対して実行されます。"
            },
            "from file tab description": {
                "create task": "選択されたタスクは、アップロードされたファイルで指定されたデバイス向けに作成されます。",
                "general": "選択されたアクションは、アップロードされたファイルで指定されたデバイスに対して実行されます。"
            }
        },
        "unlocker": {
            "generate unlock key": "アンロックキーを生成する",
            "generate unlock key description": "以下のフィールドにTCTから取得したデバイスの「ロックコード」を入力してください。「生成」ボタンを押すとアンロックキーが生成されます。このキーをTCTで使用してデバイスのロックを解除してください。",
            "invalid lock code": "無効なデバイスロックコードです。",
            "limit reached": "生成可能なアンロックキーの最大数に達しました。",
            "lock code": "ロックコード",
            "unlock key": "キーのロック解除",
            "unlock key success message": "ロック解除キーが正常に生成されました。"
        },
        "upload file": "ファイルをアップロード",
        "upload file description": "ドラッグ＆ドロップフィールドまたはファイル選択により、最大{{count}}個のファイルを一度にアップロードできます。",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "ファームウェアバージョン04.00.00以降にはダウングレード保護機能が搭載されています。ファームウェア変更の詳細については、<1>Teltonika GPS Wiki</1>のドキュメントをご確認ください。「次へ」ボタンを押すことで、上記の内容に同意し理解したことを確認します。",
        "upload firmware unsupported info": "このバージョンへの更新は利用できません。Teltonikaサポートまたは担当営業担当者にお問い合わせください。",
        "use at least one filter": "少なくとも1つのフィルターを使用してください",
        "user": "ユーザー",
        "valid until": "有効期限",
        "valid until date disable description": "このフィールドは「期間」が「カスタム」に設定されている場合のみ変更可能です",
        "vehicle model": "モデル"
    },
    "Dropzone": {
        "add file": "ファイルを追加",
        "add files": "ファイルを追加",
        "drop file to upload": "アップロードするファイルをここにドロップしてください",
        "drop files to upload": "ファイルをドロップしてアップロード",
        "error uploading the file": "ファイルのアップロード中にエラーが発生しました",
        "file invalid type": "無効なファイル形式が選択されました。",
        "file successfully uploaded": "ファイルのアップロードが正常に完了しました",
        "file syntax": "ファイル形式は以下の通りです：",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "最大ファイル制限に達しました。",
        "only one file can be attached": "添付できるファイルは1つだけです。",
        "or drop file to upload": "またはファイルをドロップしてアップロード",
        "or drop files to upload": "またはファイルをドロップしてアップロード",
        "rows detected": "ファイル内の行数を正常に検出しました",
        "select file": "ファイルを選択",
        "select files": "ファイルを選択",
        "select file type": "まずファイルタイプを選択してください。",
        "supported formats": "対応フォーマット",
        "too long file name": "ファイル名が長すぎます。最大{{maxLength}}文字まで許可されています。",
        "too many files description": "選択したファイルをアップロードした後、残りのファイルをアップロードできます。",
        "too many files title": "一度に添付できるファイルの最大数は{{maxFiles}}です。"
    },
    "Error": {
        "error": "エラー",
        "message wait": "エラーが修正されるまで、しばらくお待ちください。",
        "title": "問題が発生しました！"
    },
    "Feature highlight": {
        "got it": "了解しました",
        "new feature": "新機能！",
        "scenarios description": "現在、デバイス上で以下のシナリオのいずれかを設定できます：速度超過検知、衝突検知、牽引検知。"
    },
    "Filter": {
        "access group": "",
        "activity_status": "ステータス",
        "all permissions": "すべての権限",
        "batch_id": "バッチID",
        "company_id": "会社",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "作成者：",
        "current_configuration": "設定",
        "current_firmware": "ファームウェア",
        "device_imei": "デバイスのIMEI",
        "file type": "ファイルタイプ",
        "filtered by": "フィルター処理済み",
        "filters used": "使用されたフィルター",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "グループ",
        "id": "ID",
        "Invalid company": "無効な会社",
        "model": "モデル",
        "model_platform": "プラットフォーム",
        "Multiple companies": "複数企業",
        "parent company": "親会社",
        "permission": "権限",
        "permission status": "ステータス",
        "role": "役割",
        "spec_id": "Spec ID",
        "status_id": "ステータス",
        "supported_task_type": "タスクタイプ",
        "table filters": "テーブルフィルター",
        "task type": "タスクタイプ",
        "task_queue": "キュー",
        "type": "タイプ",
        "user status": "ステータス"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "ADASファームウェアのファイルサイズはゼロではいけません。",
        "ADAS firmware is invalid.": "ADASファームウェアが無効です。",
        "All notifications were deleted.": "すべての通知が削除されました。",
        "All notifications were marked as read.": "すべての通知が既読としてマークされました。",
        "At least one user role must be provided.": "少なくとも1つのユーザーロールを提供する必要があります。",
        "Attributes length is invalid": "属性の長さが無効です。",
        "Banner was updated.": "",
        "Batch was discarded": "バッチは破棄されました。",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "一括属性更新ジョブが作成されました。デバイスの属性はまもなく更新されます。",
        "Bulk create job was created. Devices will be created shortly.": "一括作成ジョブが作成されました。デバイスはまもなく作成されます。",
        "Bulk create job was created. Tasks will be created shortly.": "一括ジョブ作成が実行されました。タスクはまもなく作成されます。",
        "Bulk delete job was created. Companies will be removed shortly.": "一括削除ジョブが作成されました。企業はまもなく削除されます。",
        "Bulk delete job was created. Devices will be removed shortly.": "一括削除ジョブが作成されました。デバイスはまもなく削除されます。",
        "Bulk delete job was created. Files will be removed shortly.": "一括削除ジョブが作成されました。ファイルはまもなく削除されます。",
        "Bulk delete job was created. Groups will be removed shortly.": "一括削除ジョブが作成されました。グループはまもなく削除されます。",
        "Bulk delete job was created. Product codes will be removed shortly.": "一括削除ジョブが作成されました。製品コードはまもなく削除されます。",
        "Bulk delete job was created. Users will be removed shortly.": "一括削除ジョブが作成されました。ユーザーはまもなく削除されます。",
        "Bulk task create job was created. Tasks will be created shortly.": "一括タスクジョブが作成され、タスクはまもなく表示されます。タスクは「タスクグループ」ページのタスクグループ詳細で確認できます。",
        "Bulk update job was created. Devices will be updated shortly.": "一括更新ジョブが作成されました。デバイスはまもなく更新されます。",
        "Bulk update job was created. Tasks will be updated shortly.": "一括更新ジョブが作成されました。タスクはまもなく更新されます。",
        "Can adapter was added.": "Canアダプターが追加されました。",
        "Can adapter was deleted.": "Canアダプターが削除されました。",
        "Can adapter was updated.": "Canアダプターが更新されました。",
        "Can chip firmware file size can't be zero": "チップファームウェアのファイルサイズはゼロにできません。",
        "Can chip firmware is invalid.": "チップファームウェアが無効な場合があります。",
        "Cannot delete company. Company is not empty.": "会社は削除できません。会社は空ではありません。",
        "Cannot delete file. It is used by pending or running tasks.": "ファイルを削除できません。保留中または実行中のタスクに使用されています。",
        "Cannot delete file. It is used by running tasks.": "ファイルを削除できません。実行中のタスクで使用中です。",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "デバイスに割り当てられた製品コードは削除できません。",
        "check your email for details": "",
        "Companies count limit exceeded.": "企業数の上限を超えました。",
        "Companies in the request must belong to the selected root.": "リクエスト対象の企業は、選択されたルートに属している必要があります。",
        "Company merge job was created. It will be merged shortly.": "会社合併ジョブが作成されました。まもなく合併されます。",
        "Company name already exist.": "会社名は既に存在します。",
        "Company level change is not allowed.": "会社レベルでの変更は許可されていません。",
        "Company level successfully changed": "会社レベルが正常に変更されました。",
        "company level successfully reverted": "会社レベルは正常に自動割り当てレベルへ復元されました。",
        "Company not allowed to be merged": "会社は合併が許可されていません。",
        "company resource limits changed": "会社のリソース制限が正常に変更されました。",
        "Company was created.": "会社が設立されました。",
        "Company was deleted.": "会社は削除されました。",
        "Company was updated.": "会社情報が更新されました。",
        "compatibilities added": "同期中に追加された互換性：{{count}}件。",
        "compatibilities synchronized": "不足していた互換性を正常に同期しました。",
        "Configuration cannot have FOTA functionality disabled": "設定においてFOTA機能が無効化されることは許容されない。",
        "Configuration file cannot contain duplicate parameters": "設定ファイルには重複するパラメータを含めることはできません。",
        "Configuration file size can't be zero": "設定ファイルのサイズはゼロにできません。",
        "Configuration files count limit exceeded.": "設定ファイルの件数制限を超えました。",
        "Configuration version must be defined": "構成バージョンを定義する必要があります。",
        "custom resource limits successfully reverted": "カスタムリソース制限が自動的に割り当てられた制限値に正常に復元されました。",
        "Custom roles feature is not enabled.": "カスタムロール機能は、プレミアム企業レベルのユーザーのみが利用可能です。以前に作成されたカスタムロールは削除できます。",
        "desktop license added": "Desktopライセンス「{{name}}」が正常に追加されました。",
        "Devices already are in target company": "デバイスは既に対象企業に存在します。",
        "Device already exists.": "デバイスは既に存在します。",
        "Device bulk attribute update file cannot be empty": "デバイス一括属性更新ファイルは空にしてはいけません。",
        "Device bulk attribute update file should be .csv": "デバイス一括属性更新ファイルは.csv形式である必要があります。",
        "Device export limit reached. You can not export more than 100000 devices": "デバイスのエクスポート上限に達しました。100,000台を超えるデバイスのエクスポートはできません。",
        "Device import limit reached. You can not import more than 100 devices": "デバイスのインポート上限に達しました。100台を超えるデバイスのインポートはできません。",
        "Device model and task type compatibility was updated.": "デバイスモデルとタスクタイプの互換性が更新されました。",
        "Device model was created.": "デバイスモデルが作成されました。",
        "Device model was deleted.": "デバイスモデルが削除されました。",
        "Device model was updated.": "デバイスモデルが更新されました。",
        "Device not found": "デバイスが見つかりません。",
        "Device Transfer job was created. Devices will be transfered shortly.": "デバイス転送ジョブが作成されました。デバイスはまもなく転送されます。",
        "Device was added.": "デバイスが追加されました。",
        "Device was deleted.": "デバイスが削除されました。",
        "Device was updated.": "デバイスが更新されました。",
        "Email or password is incorrect.": "入力されたメールアドレスまたはパスワードが正しくないようです。",
        "Failed to create Product code": "製品コードの作成に失敗しました。",
        "Failed to delete Product code": "製品コードの削除に失敗しました。",
        "Failed to import devices.": "デバイスのインポートに失敗しました。",
        "Failed to Read Product code": "製品コードの読み取りに失敗しました。",
        "Failed to retry failed tasks": "失敗したタスクの再試行に失敗しました。",
        "Failed to update Product code": "製品コードの更新に失敗しました。",
        "Failed to update task for retry": "失敗したタスクの再試行に失敗しました。",
        "Field is not valid": "フィールドが無効です。",
        "File description is too long. Max 255 characters allowed.": "ファイルの説明が長すぎます。最大255文字まで許可されています。",
        "File exceeds entries limit of 10000.": "ファイルが10,000件の登録上限を超えています。",
        "File must not contain duplicated IMEIs": "ファイルには重複したIMEIを含めることはできません。",
        "File must not contain IMEIs that already exist in database.": "ファイルには、データベースに既に存在するIMEIを含めることはできません。",
        "File must not contain invalid IMEIs": "ファイルには無効なIMEIが含まれていてはならない。",
        "File name is too long. Max 255 characters allowed.": "ファイル名が長すぎます。最大255文字まで許可されています。",
        "File name should not contain illegal characters or symbols": "ファイル名には使用できない文字が含まれています。",
        "File not found": "ファイルが見つかりません。",
        "File was deleted.": "ファイルが削除されました。",
        "File was successfully uploaded.": "ファイルのアップロードが正常に完了しました。",
        "File was updated.": "ファイルが更新されました。",
        "File was uploaded. Devices will be imported shortly.": "ファイルがアップロードされました。デバイスはまもなくインポートされます。",
        "File will be created shortly. Check files in a second.": "ファイルはまもなく作成されます。すぐにファイルを確認してください。",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "ファームウェアファイルのサイズはゼロではいけません。",
        "First device in file not found.": "ファイル内の最初のデバイスが見つかりません。",
        "Forbidden": "アクセス禁止。",
        "Group name already exist.": "そのグループ名は既に存在します。",
        "Group was added.": "「'{{group}}'」が正常に作成されました。",
        "Group was created.": "グループが作成されました。",
        "Group was deleted.": "グループが削除されました。",
        "Group was updated.": "グループが更新されました。",
        "Invalid device bulk update attribute": "無効なデバイス一括更新属性。",
        "Invalid email address.": "無効なメールアドレスです。",
        "Invalid file contents": "無効なファイル内容。",
        "Invalid file name": "無効なファイル名です。",
        "Invalid invitation token.": "無効な招待トークンです。",
        "Invalid token": "無効なトークンです。",
        "Invalid token length": "トークンの長さが無効です。",
        "Internal Server Error": "内部サーバーエラー。",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "ライセンスが削除されました。",
        "License was updated.": "ライセンスが更新されました。",
        "Maximum companies hierarchy depth exceeded": "企業階層の最大深さを超過しました",
        "Maximum device group size exceeded.": "デバイスグループの最大サイズを超えました。",
        "Method Not Allowed": "メソッドが許可されていません。",
        "Network Error": "ネットワークエラー。",
        "No changes made": "変更はありませんでした。",
        "No resources found.": "リソースが見つかりませんでした。",
        "not allowed to affect batch": {
            "description": "このタスクグループを作成したユーザーの会社を管理していることを必ずご確認ください。",
            "title": {
                "approve": "このバッチを承認する権限がありません。",
                "discard": "このバッチを破棄する権限がありません。"
            }
        },
        "Not Found": "見つかりませんでした。",
        "Notification was deleted.": "通知が削除されました。",
        "notify when done title": "処理に時間がかかる場合があります。完了通知を受け取るには、下のボタンを押してこの画面を閉じてください。",
        "Obd record was created.": "OBDレコードが作成されました。",
        "Obd record was updated.": "OBD記録が更新されました。",
        "offline license added": "オフラインライセンス「{{name}}」が正常に追加されました。",
        "Offline license was deleted.": "オフラインライセンスが削除されました。",
        "Only id_list source is supported.": "id_listソースのみがサポートされています。",
        "Only users with Teltonika email can be invited into internal companies.": "Teltonikaのメールアドレスを持つユーザーのみが社内組織に招待可能です。",
        "Only users with Teltonika email can be moved into internal companies.": "Teltonikaのメールアドレスを持つユーザーのみが内部企業に移動できます。",
        "Parent company cannot be a descendant of the updated company.": "親会社は更新された会社の子会社であってはならない。",
        "Password reset link was sent to Your email.": "パスワード再設定リンクがお客様のメールアドレスに送信されました。",
        "Password reset token is invalid, expired or related user no longer exists.": "パスワードリセットトークンが無効、期限切れ、またはユーザーが存在しません。",
        "Password was changed.": "パスワードが変更されました。",
        "product code added": "製品コード「{{code}}」が正常に追加されました。",
        "Product code is too long. Max 200 characters allowed.": "製品コードが長すぎます。最大200文字まで許可されています。",
        "ProductCode already exists.": "製品コードは既に存在します。",
        "ProductCode not found": "製品コードが見つかりません。",
        "Product code was deleted.": "製品コードが削除されました。",
        "Product code was updated.": "製品コードが更新されました。",
        "Retry failed tasks job was created": "失敗したタスクの再試行ジョブが作成されました。",
        "Role cannot be set for an internal user.": "内部ユーザーにはロールを設定できません。",
        "Role was created.": "ロールが作成されました。",
        "Role was deleted.": "ロールが削除されました。",
        "Role was updated.": "役割が更新されました。",
        "selected company changed": "選択された会社が変更されました。",
        "Selected firmware bundle is not supported by the device.": "選択されたファームウェアバンドルはこのデバイスではサポートされていません。",
        "Server Error": "サーバーエラー。",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "SMSが送信されました。",
        "Something went wrong while saving a new password.": "新しいパスワードの保存中に問題が発生しました。",
        "Successfully logged out.": "ログアウトに成功しました。",
        "System Admin user level is required in order to perform this action.": "この操作を実行するには、システム管理者ユーザーレベルが必要です。",
        "Target company cannot be a descendant of source company.": "対象会社は、元の会社の子会社であってはなりません。",
        "Task create limit exceeded.": "100,000台を超えるデバイスに対してタスクグループを作成することはできません。",
        "Task type is not retriable": "タスクタイプは再実行不可",
        "Task was added.": "タスクが追加されました。",
        "task was created": "{{imei}} 向けにタスクが作成されました（「{{taskType}}」）。このタスクは、デバイス詳細の「デバイス」ページにある「タスク」セクションで確認できます。",
        "Task was updated.": "タスクが更新されました。",
        "Tasks were approved": "タスクが承認されました。",
        "The given data was invalid.": "指定されたデータは無効でした。",
        "time zone changed": "タイムゾーンが変更されました。",
        "Token cannot be null or empty": "トークンはnullまたは空であってはなりません。",
        "token created": "APIトークンの作成に成功しました。",
        "Token has expired": "トークンが期限切れになりました。",
        "Token's and token's owner companies do not match": "トークンとトークンの所有企業は一致しません。",
        "Token was deleted.": "トークンが削除されました。",
        "Too many resources in the request": "リクエスト内のリソースが多すぎます",
        "Too Many Requests": "リクエストが多すぎます。",
        "Transfer token created": "転送トークンが作成されました。",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "ユーザーに対して二要素認証は既に有効化されています。",
        "Two factor authentication successfully disabled.": "二要素認証が無効化されました。",
        "Unable to send SMS. This device does not have a GSM number assigned.": "SMSを送信できません。このデバイスには割り当てられたGSM番号がありません。",
        "Unable to validate Your request.": "リクエストを検証できませんでした。",
        "Unauthenticated.": "未認証。",
        "Unauthorized": "権限がありません。",
        "User access level is not valid": "ユーザーアクセスレベルが無効です",
        "User invitation was revoked": "招待は正常にキャンセルされました。",
        "User invitation was re-sent": "ユーザー招待を再送信しました。",
        "User is already in the system.": "ユーザーは既にシステムにログイン済みです。",
        "User was created.": "ユーザーが作成されました。",
        "User was deleted.": "ユーザーが削除されました。",
        "User was invited.": "ユーザー招待が正常に送信されました。",
        "User was updated": "ユーザーが更新されました。",
        "Users count limit exceeded.": "ユーザー数の上限を超えました。",
        "Your password has been changed.": "パスワードが変更されました。"
    },
    "General": {
        "0": "ユーザー",
        "5": "サポート",
        "10": "管理者",
        "15": "管理者マネージャー",
        "19": "",
        "20": "システムユーザー",
        "99": "スーパーユーザー",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "会社作成",
        "Company.Delete": "会社削除",
        "Company.Merge": "企業合併",
        "Company.Update": "会社情報更新",
        "Device.Export": "デバイスのエクスポート",
        "Device.Read": "デバイス読み取り",
        "Device.SecretsRead": "",
        "Device.Transfer": "デバイス転送",
        "Device.Unlock": "デバイスのロック解除",
        "Device.Update": "デバイス更新",
        "DeviceGroup.Create": "デバイスグループの作成",
        "DeviceGroup.Delete": "デバイスグループの削除",
        "DeviceGroup.Read": "デバイスグループ読み取り",
        "DeviceGroup.Update": "デバイスグループ更新",
        "File.Create": "ファイル作成",
        "File.Delete": "ファイル削除",
        "File.Download": "ファイルダウンロード",
        "File.Read": "ファイル読み取り",
        "File.TctWebAccess": "TCT web",
        "File.Update": "ファイル更新",
        "Role.Create": "ロール作成",
        "Role.Delete": "ロール削除",
        "Role.Read": "ロール読み取り",
        "Role.Update": "ロール更新",
        "Task.Create": "タスク作成",
        "Task.Read": "タスク読み取り",
        "Task.Retry": "タスク再試行",
        "Task.Update": "タスク更新",
        "TaskGroup.Read": "タスクグループ読み取り",
        "TctIntegration.Access": "TCT統合",
        "Token.Create": "トークン作成",
        "Token.Delete": "トークン削除",
        "Token.Read": "トークン読み取り",
        "User.Create": "",
        "User.Delete": "ユーザー削除",
        "User.Read": "ユーザー閲覧",
        "User.Update": "ユーザー更新",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "1-Wire認証リスト",
        "1_wire_authorization_list": "1-Wire認証リスト",
        "Active": "アクティブ",
        "adas_firmware": "ADASファームウェア",
        "apx_firmware": "APXファームウェア",
        "assign can package": "CANパッケージを割り当てる",
        "assigned package": "割り当てられたパッケージ",
        "automatic": "自動化",
        "banner management": "",
        "batches": "タスクグループ",
        "black_box": "ブラックボックス",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLEファームウェア",
        "blue_nrg": "BlueNRGファームウェア",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Bluetooth認証リスト",
        "bluetooth_authorization_list": "Bluetooth認証リスト",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "互換性なし",
                "true": "互換性あり"
            },
            "web_editor_support": {
                "false": "TCT webはサポート対象外",
                "true": "TCT web対応"
            }
        },
        "can": "CAN",
        "can adapter name": "CANアダプタ名",
        "can bootstring": "ブートストリング",
        "can configuration": "OEM設定",
        "can_debug_log": "CANデバッグログ",
        "can oem file package": "OEM向けファイルパッケージ",
        "can oem file vehicle": "OEMファイル車両",
        "can package": "OEMパッケージ",
        "can program number": "CANプログラム番号",
        "can revision": "CANリビジョン",
        "can software date": "CANソフトウェア日付",
        "can type": "CANタイプ",
        "Cancelled": "キャンセルされました",
        "cancel task": "タスクをキャンセル",
        "can_chip_firmware": "FM CANチップファームウェア",
        "carrier_advance_firmware": "Carrier Advanceファームウェア",
        "carrier_advance_settings": "Carrier Advance設定",
        "carrier_apx_firmware": "Carrier APXファームウェア",
        "carrier_apx_settings": "Carrier APX設定",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Carrier温度ロガーファイル",
        "certificate": "証明書",
        "click for more details": "詳細はこちらをクリック",
        "client ip": "クライアントIP",
        "clone model": "デバイスモデルの複製",
        "collapse menu": "メニューを折りたたむ",
        "companies": "企業",
        "company": "会社",
        "company level": "企業レベル",
        "company type": "会社形態",
        "company name": "会社名",
        "Completed": "完了",
        "Completed with errors": "エラーを伴って完了しました",
        "configuration": "設定",
        "configuration_36": "設定 (FM36)",
        "configuration_64": "設定 (FMB64)",
        "crash_dump": "クラッシュダンプログ",
        "created at": "作成日",
        "created by": "作成者：",
        "custom": "カスタム",
        "custom resource limits": "カスタムリソース制限",
        "dashboard": "ダッシュボード",
        "delete desktop license": "Desktopライセンスを削除",
        "delete offline license": "オフラインライセンスを削除",
        "desktopLicenses": "Desktopライセンス",
        "device_export_file_csv": "デバイスエクスポートファイル（.csv）",
        "device_export_file_xlsx": "デバイスエクスポートファイル (.xlsx)",
        "deviceModels": "モデル",
        "deviceModelTaskCompatibilities": "互換性",
        "device_transfer_report": "デバイス転送レポート",
        "device group": "グループ",
        "DeviceImportFile": "デバイスインポートファイル",
        "devices": "デバイス",
        "download file": "ファイルをダウンロード",
        "download offline license": "オフラインライセンスをダウンロード",
        "dsm_firmware": "DSMファームウェア",
        "dtb": "DTB",
        "edit compatibility": "デバイスの互換性を編集",
        "edit model": "デバイスモデルの編集",
        "edit company": "会社編集",
        "edit desktop license": "Desktopライセンスを編集",
        "edit device": "デバイス編集",
        "edit file": "ファイルを編集",
        "edit group": "グループ編集",
        "edit in tct web": "TCT webで編集",
        "edit in tct web disabled": "TCT webでの編集機能は、プレミアム企業レベルでのみ利用可能です。",
        "edit product code": "製品コードを編集する",
        "edit role": "編集ロール",
        "edit smart group": "スマートグループを編集",
        "edit user": "ユーザー編集",
        "Empty": "空",
        "enter here": "こちらから入力してください",
        "exception_info": "例外情報",
        "Executing": "実行中",
        "expand menu": "メニューを展開",
        "Expired": "期限切れ",
        "Factory": "",
        "Failed": "失敗",
        "file": "ファイル",
        "file data": "ファイルデータ",
        "files": "ファイル",
        "file deleted": "ファイルが削除されました",
        "firmware": "ファームウェア",
        "firmware_36": "ファームウェア (FM36)",
        "firmware_64": "ファームウェア (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "ファームウェアバンドル",
        "fw_bundle_ble": "バンドル - BLEファームウェア",
        "fw_bundle_ble_dtb": "バンドル - BLE DTB",
        "fw_bundle_can": "バンドル - CANファームウェア",
        "fw_bundle_can_dtb": "バンドル - CAN DTB",
        "fw_bundle_dtb": "バンドル - メイン DTB",
        "fw_bundle_mainfw": "バンドル - メインファームウェア",
        "generic": "",
        "global_configuration": "グローバル設定",
        "global_firmware": "グローバルファームウェア",
        "gnssm_download_assistant": "GNSS-M ダウンロード アシスタント",
        "gnssm_firmware": "GNSS-Mファームウェア",
        "group": "グループ",
        "groups": "デバイスグループ",
        "hardware key": "ハードウェアキー",
        "id": "ID",
        "id_collection_file": "ID収集ファイル",
        "imei restriction": "IMEI制限",
        "Inactive": "非アクティブ",
        "Invalid": "無効",
        "invalid model": "無効なモデル",
        "invalid model_name": "無効なモデル",
        "InvitationExpired": "期限切れの招待",
        "InvitationPending": "招待待ち",
        "Legacy": "レガシー",
        "legacy model": "レガシーモデル",
        "legacy model_platform": "レガシープラットフォーム",
        "legacy platform": "レガシープラットフォーム",
        "license has expired": "ライセンスが期限切れになりました",
        "loading": "読み込み中",
        "log": "ログ",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "マニュアル",
        "ManualGeofenceList": "",
        "manual geofence list": "手動ジオフェンスシナリオ一覧",
        "manual_geofence_list": "手動ジオフェンスシナリオ一覧",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "MeiG モデムファームウェア",
        "menu": "メニュー",
        "modem version": "モデム版",
        "netprisma_modem_firmware": "NETPRISMA モデムファームウェア",
        "nmea_log": "NMEAログ",
        "no": "いいえ",
        "no results": "結果が見つかりませんでした",
        "no results description": "{{name}}がFOTA WEBにアップロードされるとすぐに、ここでデータを確認できるようになります",
        "not assigned": "未割り当て",
        "not assigned configuration_file_id": "設定未割り当て",
        "not assigned current_configuration": "設定未割り当て",
        "not assigned current_firmware": "ファームウェア未割り当て",
        "not assigned firmware_file_id": "ファームウェア未割り当て",
        "not assigned group_id": "グループ未割り当て",
        "not assigned model": "モデル未割り当て",
        "not assigned spec_id": "Spec ID未割り当て",
        "not assigned task_type": "タスクタイプ未割り当て",
        "obd_chip_firmware": "FM OBDチップファームウェア",
        "obd chip firmware version": "OBDチップファームウェアバージョン",
        "Offline": "オフライン",
        "offline licenses": "オフラインライセンス",
        "Online": "オンライン",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "または",
        "other": "その他",
        "Pending": "保留中",
        "Pending approval": "承認待ち",
        "permission disabled": "無効化",
        "permission enabled": "有効化済み",
        "productCodes": "製品コード",
        "psub": "サブスクリプションファイル",
        "quectel_fw": "クエックテル モデム ファームウェア (quectel_fw)",
        "quectel_modem_firmware": "クエックテル モデム ファームウェア",
        "resend invite": "招待状を再送信する",
        "restricted": "制限付き",
        "retry": "再試行",
        "roles": "役割と権限",
        "Running": "稼働中",
        "RxAutoscan": "CANファイルの自動スキャン受信",
        "RxBlackBox": "ブラックボックスを受信",
        "RxBluetoothAuthorizationList": "Bluetooth認証リストの受信",
        "RxCanDebugLog": "CANデバッグログを受信する",
        "RxCarrierExtractions": "Carrier extractionsデータのダウンロード",
        "RxCarrierLoggerFiles": "Carrier温度ロガーファイルのダウンロード",
        "RxConfiguration": "設定を受信",
        "RxCrashDump": "クラッシュダンプログを受信する",
        "RxExceptionInfo": "例外情報を受信する",
        "RxLog": "内部ログを受信する",
        "RxManualGeofenceList": "手動ジオフェンスシナリオリストの受信",
        "RxNmeaLog": "NMEAログを受信する",
        "RxOneWireAuthorizationList": "1-Wire認証リストを受信する",
        "RxWdLog": "ウォッチドッグ（WD）ログを受信する",
        "select company": "会社を選択",
        "SetBindSim": "デバイスを現在のSIMカードと紐付ける",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "機能を無効化",
        "SetEnableFeature": "機能の有効化",
        "SetForceLockSim": "強制ロックSIM",
        "SetUnbindSim": "SIMカード付きデバイスの紐付け解除",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "ステータス",
        "task details": "タスクの詳細",
        "task groups": "タスクグループ",
        "tasks": "タスク",
        "tasksCompatibility": "タスク互換性",
        "task type": "タスクタイプ",
        "Tct": "",
        "time zone": "タイムゾーン",
        "total": "トータル",
        "tutorials": "チュートリアル",
        "TxAdasFirmware": "ADASファームウェアのアップロード",
        "TxAgpsMt3333": "AGPSMファイルの転送",
        "TxAgpsQuectelL89": "AGPSQファイルの転送",
        "TxAutoscanCanConfiguration": "OEMファイルの自動スキャンアップロード",
        "TxBleFirmware": "BLEファームウェアのアップロード",
        "TxBlueNrgFirmware": "BlueNrgファームウェアのアップロード",
        "TxBluetoothAuthorizationList": "Bluetooth認証リストのアップロード",
        "TxBundleBle": "BLEファームウェアのアップロード",
        "TxBundleBleDtb": "BLE DTBのアップロード",
        "TxBundleCan": "CANファームウェアのアップロード",
        "TxBundleCanDtb": "CAN DTBのアップロード",
        "TxBundleDtb": "メインDTBのアップロード",
        "TxBundleFirmware": "メインファームウェアのアップロード",
        "TxCanAdapterModeChange": "外部CANアダプターのモード変更",
        "TxCanAdapterModeChangeInternal": "内部CANアダプタのモードを変更する",
        "TxCanAdapterUpdate": "CANアダプタのファームウェアをアップロードする",
        "TxCanAdapterUpdateInternal": "内部CANアダプターの更新",
        "TxCanChipFirmware": "FMXY50 CANチップファームウェアのアップロード",
        "TxCanConfiguration": "OEMファイルのアップロード",
        "TxCarrierAdvanceFirmware": "Carrier Advanceファームウェアの更新",
        "TxCarrierAdvanceSettings": "Carrier Advance設定の更新",
        "TxCarrierApxFirmware": "Carrier APXファームウェアの更新",
        "TxCarrierApxSettings": "Carrier APX設定の更新",
        "TxConfiguration": "設定のアップロード",
        "TxDsmFirmware": "DSMファームウェアのアップロード",
        "TxDtb": "DTBをアップロード",
        "TxFirmware": "ファームウェアのアップロード",
        "TxFirmwareBundle": "ファームウェアバンドルコンテナのアップロード",
        "TxFirmwareBundleParts": "ファームウェアバンドルのアップロード",
        "TxFotaCertificate": "FOTA証明書の更新",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "GNSS-M ダウンロードアシスタントのアップロード",
        "TxGNSSMFirmware": "GNSS-Mファームウェアのアップロード",
        "TxManualGeofenceList": "手動ジオフェンスシナリオリストのアップロード",
        "TxMeigModemDeltaFirmware": "MeiG Delta モデム ファームウェアのアップロード",
        "TxNetprismaModemDeltaFirmware": "NETPRISMA Delta モデム ファームウェアのアップロード",
        "TxObdChipFirmware": "OBDチップの更新",
        "TxObdConfig": "OBD設定ファイルの転送",
        "TxOneWireAuthorizationList": "1-Wire認証リストのアップロード",
        "TxPSub": "サブスクリプションファイルの転送",
        "TxQuectelModemDeltaFirmware": "Quectel Deltaモデムファームウェアのアップロード",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "ユーザーTLS証明書のアップロード",
        "users": "ユーザー",
        "Unknown": "不明",
        "unknown": "不明",
        "unknown model_platform": "不明なプラットフォーム",
        "unknown origin": "",
        "unknown platform": "不明なプラットフォーム",
        "unrestricted": "制限なし",
        "Verifying": "検証中",
        "vin": "VIN",
        "vip status": "VIPステータス",
        "wd_log": "WDログ",
        "yes": "はい"
    },
    "Maintenance": {
        "title": "お待ちください！現在メンテナンス中です。"
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} はサーバーエラーのため失敗しました。",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "選択したすべてのタスクをキャンセルする権限がありません。一部のタスクは異なる企業のリソースに関連付けられています。",
            "Cancel tasks action failed. No resources found.": "選択条件に一致するタスクはありませんでした。タスク選択内容をご確認の上、再度お試しください。",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "会社「{{SourceCompanyName}}」（{{SourceCompanyId}}）は「{{TargetCompanyName}}」（{{TargetCompanyId}}）に合併されました。",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "会社合併に失敗しました。設定または権限の不一致により、会社「{{SourceCompanyId}}」と「{{TargetCompanyId}}」を合併できません。",
            "Create device group tasks action failed. No resources found.": "スマートグループへのタスク作成に失敗しました。ファイルの再割り当てをお試しください。",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{GroupId}} デバイス群向けに {{CreatedTaskCount}} 件のタスクが作成されました。",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "選択した全デバイスに対してタスクを作成する権限がありません。一部のデバイスは異なる企業に属しています。",
            "Create tasks action failed. No resources found.": "選択条件に一致するデバイスはありませんでした。デバイスの選択内容を確認の上、再度お試しください。",
            "Create tasks action failed. No resources processed.": "選択したデバイスの処理に失敗しました。タスクグループを再度作成してください。",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "選択した全企業を削除する権限がありません。一部の企業は直接管理下にはありません。",
            "Delete companies action failed. No resources found.": "該当する企業はありませんでした。企業選択内容をご確認の上、再度お試しください。",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "選択したすべてのファイルを削除する権限がありません。一部のファイルは異なる企業のリソースに関連付けられています。",
            "Delete files action failed. No resources found.": "選択したファイルに一致するものはありませんでした。ファイルの選択内容を確認の上、再度お試しください。",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "選択したすべてのデバイスグループを削除する権限がありません。一部のデバイスグループには異なる企業のリソースが含まれています。",
            "Delete groups action failed. No resources found.": "選択した条件に一致するデバイスグループはありません。デバイスグループの選択内容を確認の上、再度お試しください。",
            "Delete product codes action failed. No resources found.": "選択した製品コードに一致するものはありません。製品コードの選択内容を確認の上、再度お試しください。",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "選択した全ユーザーを削除する権限がありません。一部のユーザーは異なる企業に所属しています。",
            "Delete users action failed. No resources found.": "選択条件に一致するユーザーが見つかりませんでした。ユーザー選択内容を確認の上、再度お試しください。",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}}台のデバイスが「{{Filename}}」にエクスポートされました。",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}}台のデバイスがインポートされました。",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}}台のデバイスを処理、{{TasksCreatedCount}}件のタスクを作成。",
            "Export devices action failed. No resources found.": "選択条件に一致するデバイスはありませんでした。デバイスの選択内容を確認の上、再度お試しください。",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "タスクグループ {{BatchId}} において、{{FailedTaskCount}} 件のタスクが保留状態に戻りました。",
            "Invalid request scope. Resources must belong to single root.": "無効なリクエストスコープ。リソースは単一のルートに属している必要があります。",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}}社が削除されました。",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}}個のデバイスグループが削除されました。",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}}個のデバイス属性が更新されました。",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}}個のデバイスモデルが削除されました。",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}}台のデバイスを更新しました。",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} 個のファイルが削除されました。",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}}個の製品コードが削除されました。",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} 件のタスクがキャンセルされました。",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} 件のタスクを更新しました。",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} ユーザーが削除されました。",
            "Retry tasks action failed. No resources found.": "選択条件に一致するタスクはありませんでした。タスク選択内容をご確認の上、再度お試しください。",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "選択した全デバイスの転送権限がありません。一部のデバイスは異なる企業に属しています。",
            "Transfer devices action failed. No resources found.": "選択条件に一致するデバイスはありませんでした。デバイスの選択内容を確認の上、再度お試しください。",
            "Transfer devices action failed. No resources processed.": "選択したデバイスの処理に失敗しました。デバイスを再度転送してください。",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TotalDevicesToTransfer}}台のデバイスのうち、{{TransferredDevicesCount}}台が転送されました。",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "選択したすべてのデバイスを更新する権限がありません。一部のデバイスは異なる企業に属しています。",
            "Update devices action failed. No resources found.": "選択条件に一致するデバイスはありませんでした。デバイスの選択内容を確認の上、再度お試しください。",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "選択した全デバイスの属性を更新する権限がありません。一部のデバイスは異なる企業に属しています。",
            "Update devices attributes action failed. No resources found.": "選択条件に一致するデバイスはありませんでした。デバイスの選択内容を確認の上、再度お試しください。",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "選択したすべてのタスクを更新する権限がありません。一部のタスクは異なる企業のリソースに関連付けられています。",
            "Update tasks action failed. No resources found.": "選択条件に一致するタスクはありませんでした。タスク選択内容をご確認の上、再度お試しください。",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "通知なし",
        "notifications": "通知",
        "notifications will be listed": "新しい通知はここに表示されます",
        "remove notification": "通知を削除する",
        "see previous notifications": "過去の通知を確認する",
        "timestamps": {
            "days ago": "{{days}}日前",
            "hours ago": "{{hours}}時間前",
            "minutes ago": "{{minutes}} 分前",
            "moments ago": "ついさっき"
        },
        "title": {
            "BackgroundActionFailed": "操作が失敗しました",
            "CompaniesSuccessfullyDeleted": "企業が正常に削除されました",
            "CompanyBulkDeleteFailed": "企業削除中にエラーが発生しました",
            "CompanyLevelChanged": "会社レベルが変更されました",
            "CompanyLevelDowngradeReminder": "今後の会社全体のダウングレード",
            "CompanyMergeFailed": "会社統合中にエラーが発生しました",
            "CompanySuccessfullyMerged": "企業の合併が正常に完了しました",
            "DeviceAttributesSuccessfullyUpdated": "デバイス属性が正常に更新されました",
            "DeviceBulkAttributeUpdateFailed": "デバイス属性の更新中にエラーが発生しました",
            "DeviceBulkUpdateFailed": "デバイスの更新中にエラーが発生しました",
            "DeviceExportFailed": "デバイスのエクスポート中にエラーが発生しました",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "デバイスグループが正常に削除されました",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "スマートグループタスクの作成中にエラーが発生しました",
            "DeviceGroupTasksSuccessfullyCreated": "スマートグループタスクの作成に成功しました",
            "DeviceModelBulkDeleteFailed": "デバイスモデルの削除中にエラーが発生しました",
            "DeviceModelsSuccessfullyDeleted": "デバイスモデルが正常に削除されました",
            "DevicesSuccessfullyTransferred": "デバイスの転送が正常に完了しました",
            "DevicesSuccessfullyUpdated": "デバイスが正常に更新されました",
            "DeviceTransferFailed": "デバイスの転送中にエラーが発生しました",
            "ExportFailed": "リソースのエクスポートに失敗しました",
            "ExportSucceeded": "デバイスが正常にエクスポートされました",
            "FailedTasksRetryFailed": "タスクの再試行中にエラーが発生しました",
            "FailedTasksSuccessfullyRetried": "タスクの再試行が正常に完了しました",
            "FileBulkDeleteFailed": "ファイル削除中にエラーが発生しました",
            "FilesSuccessfullyDeleted": "ファイルが正常に削除されました",
            "GroupBulkDeleteFailed": "デバイスグループの削除中にエラーが発生しました",
            "ImportFailed": "リソースのインポートに失敗しました",
            "ImportSucceeded": "デバイスが正常にインポートされました",
            "ProductCodeBulkDeleteFailed": "製品コードの削除中にエラーが発生しました",
            "ProductCodesSuccessfullyDeleted": "製品コードの削除が正常に完了しました",
            "ResourceUpdateFailed": "リソースの更新に失敗しました",
            "ResourceUpdateSucceeded": "リソースの更新に成功しました",
            "RoleBulkDeleteFailed": "ロールの削除中にエラーが発生しました",
            "RolesSuccessfullyDeleted": "ロールの削除が正常に完了しました",
            "TaskBulkCancelFailed": "タスクのキャンセル中にエラーが発生しました",
            "TaskBulkCreateFailed": "タスクグループの作成中にエラーが発生しました",
            "TaskBulkUpdateFailed": "タスクの更新中にエラーが発生しました",
            "TaskGroupSuccessfullyCreated": "タスクグループが正常に作成されました",
            "TasksPropagationFailed": "タスク配信ジョブが失敗しました",
            "TasksPropagationSucceeded": "タスク配信ジョブが成功しました",
            "TasksPropagationWarning": "タスク配信ジョブが警告付きで終了しました",
            "TasksSuccessfullyCanceled": "タスクは正常にキャンセルされました",
            "TasksSuccessfullyUpdated": "タスクが正常に更新されました",
            "UserBulkDeleteFailed": "ユーザー削除中にエラーが発生しました",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "ユーザーが正常に削除されました"
        }
    },
    "Permission actions": {
        "Access": "TCT統合",
        "Create": "作成",
        "Delete": "削除",
        "Download": "ダウンロード",
        "Export": "エクスポート",
        "Merge": "マージ",
        "Read": "読み取り",
        "Retry": "再試行",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "転送",
        "Unlock": "アンロック",
        "Update": "更新"
    },
    "Permission groups": {
        "company": "企業",
        "device": "デバイス",
        "device group": "デバイスグループ",
        "file": "ファイル",
        "role": "役割",
        "task": "タスク",
        "task group": "タスクグループ",
        "token": "トークン",
        "user": "ユーザー"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "このオプションは、会社レベルがベーシックのユーザーには無効です。",
                "token list": "ベーシック会社レベルのユーザーに対しては、API統合トークンが無効化されています。"
            },
            "custom_role_support": {
                "create role": "この機能は、プレミアム企業レベルのユーザーのみが利用できます。",
                "edit role": "この機能は、プレミアム企業レベルのユーザーのみが利用可能です。以前に作成されたカスタムロールは削除される可能性があります。",
                "edit user": "この機能は、プレミアム企業レベルのユーザーのみが利用可能です。以前に割り当てられたカスタムロールは削除される場合があります。"
            },
            "task_schedule_support": {
                "table head": "この機能は、スタンダードおよびプレミアムの会社レベルを持つユーザーのみが利用できます。以前にスケジュール付きで追加されたタスクは引き続き実行されます。"
            }
        },
        "general message": "この機能は、スタンダードおよびプレミアムの会社レベルを持つユーザーのみが利用できます。",
        "resource_limit_settings": {
            "tasks_per_group": "一度に作成できるタスクは{{limitCount}}台までです。"
        }
    },
    "Search": {
        "code": "コード",
        "description": "説明",
        "email": "メール",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "モデル",
        "name": "名称",
        "product code": "製品コード",
        "role name": "ロール名",
        "serial": "シリアル番号",
        "search by": "検索",
        "search company name": "会社名検索"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "二要素認証を無効にしようとしています。これによりFOTA WEBアカウントの安全性が損なわれる可能性があります。続行しますか？",
                    "title": "本当によろしいですか？"
                },
                "send email code": {
                    "enter code": "セキュリティのため、メールアドレス確認用のコードを入力してください。"
                },
                "send otp code": {
                    "description": "認証アプリに6桁のコードが送信されました。セキュリティのため、生成されたコードを以下のフィールドに入力してください。",
                    "no access": {
                        "authenticator": "このアカウントに関連付けられた認証アプリにアクセスできなくなった場合、二要素認証を無効化するにはパスワードの変更が必要です。",
                        "email": "このアカウントに紐付けられたメールアドレスにアクセスできなくなった場合、多要素認証を無効化するにはパスワードの変更が必要です。"
                    }
                },
                "title": "二要素認証を無効化"
            },
            "get email code": {
                "description": "次の画面でそのコードを使用してアカウントを確認してください。",
                "description modal": "そのコードを使用してアカウントを確認してください。",
                "title": "「コード送信」を押すと、一意のコードが<1>{{email}}</1>に送信されます。"
            },
            "get secret code": {
                "description": "このプロセスを完了するには、認証用モバイルアプリが必要です。例えば以下のいずれかをご利用ください："
            },
            "select authentication type": {
                "authentication app description": "Microsoft AuthenticatorやGoogle Authenticatorなどのアプリから一意のコードを取得してください。",
                "description": "アカウントとクライアントデータの安全性を確保するため、二段階認証の設定には以下のいずれかの方法をご利用ください。",
                "description modal": "ご希望の認証方法を選択してください。",
                "email": "メール",
                "email description": "サインインを試みるたびに、ワンタイムコードをメールでお送りします。",
                "recommended": "推奨",
                "title": "FOTA WEBの全ユーザーに対し、二要素認証（2FA）が必須です。",
                "title modal": "認証方法を選択"
            },
            "send email code": {
                "description": "以下のフィールドにコードを入力し、「確認」を押して続行してください。",
                "enter code": "メールアドレスを確認するため、コードを入力してください。",
                "title": "<1>{{email}}</1> 宛に一意のコードが送信されました。",
                "verification code": "認証コード"
            },
            "send otp code": {
                "click to scan code": "代わりにQRコードをスキャンするにはこちらをクリック",
                "click to type code": "コードを手動で入力する場合はこちらをクリック",
                "incorrect code": "不正なコード",
                "scan QR code": "アプリでQRコードをスキャンしてください",
                "six digit code": "アプリが生成する6桁のコード",
                "title": "このプロセスを完了するには、認証用モバイルアプリが必要です。例：<1>Microsoft Authenticator</1> または <2>Google Authenticator</2>。",
                "type text code": "テキストコードをアプリに入力してください"
            },
            "settings": {
                "description": "二要素認証は、あなたが知っているもの（パスワード）と持っているもの（スマートフォン、セキュリティキー、メール）で本人確認を行う追加のセキュリティ層です。",
                "disabled": "無効化",
                "enabled": "有効化済み",
                "title": "二要素認証"
            },
            "success message": {
                "alert": "二要素認証が正常に有効化されました。",
                "description": "メールアドレスとパスワードでログインするたびに、認証コードの入力を求めます。",
                "title": "二段階認証の設定が完了しました。",
                "title modal": "二要素認証対応！"
            },
            "title": {
                "authentication app": "認証アプリ",
                "authentication email": "認証メール",
                "is enabled": "二要素認証を有効化。",
                "protect your account": "FOTA WEBアカウントを保護する"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "パスワード変更",
            "enter current password": "現在のパスワードを入力してください",
            "enter new password": "新しいパスワードを入力してください",
            "hide password": "パスワードを非表示にする",
            "repeat new password": "新しいパスワードを再入力してください",
            "rules": {
                "lowercase letter": "少なくとも1つの小文字（a-z）を含む",
                "minimum characters": "最低12文字",
                "new and current passwords must not match": "新規パスワードと現行パスワードは一致させてはならない",
                "new passwords must match": "新しいパスワードは一致する必要があります",
                "number": "少なくとも1つの数値",
                "passwords must match": "パスワードは一致する必要があります",
                "special symbol": "少なくとも1つの特殊記号 (!@#$%^&*()-_=+)",
                "uppercase letter": "少なくとも1つの大文字（A-Z）を含む"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "パスワードを表示"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "テーブル統計",
        "statistics message": "テーブルのフィルター設定は下部の統計情報に反映されます",
        "activity": "アクティビティ",
        "model": "モデル",
        "firmware": "ファームウェア",
        "configuration": "設定",
        "statistics": "統計"
    },
    "Table": {
        "1_wire_authorization": "1-Wire認証",
        "access group": "",
        "access groups": "",
        "access level": "アクセスレベル",
        "accessories": "アクセサリー",
        "action": "アクション",
        "action date": "アクション日付",
        "assigned package": "割り当てられたパッケージ",
        "attempt count": "試行回数",
        "attribute": "属性",
        "attributes": "属性",
        "auto sync": "",
        "batch id": "バッチID",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLEファームウェア",
        "bluetooth_authorization": "Bluetooth認証",
        "bootloader": "ブートローダー",
        "can_adapter": "CANアダプター",
        "can adapter name": "CANアダプタ名",
        "can bootstring": "ブートストリング",
        "can oem file package": "OEM向けファイルパッケージ",
        "can oem file vehicle": "OEMファイル車両",
        "can package": "CANパッケージ",
        "can program number": "CANプログラム番号",
        "can software date": "CANソフトウェア日付",
        "can type": "CANタイプ",
        "carrier module id": "モジュールID",
        "carrier revision": "リビジョン",
        "carrier serial id": "シリアルID",
        "carrier settings filename": "設定ファイル名",
        "carrier unit status": "ステータス",
        "carrier unit type": "ユニットタイプ",
        "changed at": "変更日時",
        "change origin": "",
        "changes": "変更",
        "checkbox disabled": {
            "role": "静的ロールは編集または削除できません。"
        },
        "child company": "<1>{{parentCompany}}</1><0>の子会社</0>",
        "child companies": "子会社",
        "code": "コード",
        "company": "会社",
        "company hierarchy": "会社の階層構造",
        "company name": "会社名",
        "compatibility": "互換性",
        "configuration": "設定",
        "configuration details": "設定の詳細",
        "configuration type": "",
        "created at": "作成日",
        "created by": "作成者：",
        "date": "日付",
        "description": "説明",
        "device details": "デバイス詳細",
        "device company": "デバイス企業",
        "device description": "デバイス説明",
        "device group": "デバイスグループ",
        "device imei": "デバイスのIMEI",
        "device model": "デバイスモデル",
        "device seen at": "デバイス最終確認日時",
        "device serial": "デバイスシリアル番号",
        "devices": "デバイス",
        "devices count": "デバイス数",
        "Done": "完了",
        "download at": "",
        "download file": "ファイルをダウンロード",
        "dtb": "DTB",
        "edit file": "ファイルを編集",
        "email": "メール",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "タスクグループが作成されると、すぐにここで一覧を確認できます",
                    "changes": "変更が加えられるとすぐに、ここでリストを確認できるようになります",
                    "companies": "企業が作成されるとすぐに、ここで一覧を確認できるようになります",
                    "configurationChanges": "",
                    "desktopLicenses": "Desktopライセンスが作成され次第、こちらで一覧を確認できるようになります",
                    "devices": "デバイスがFOTA WEBにアップロードされると、すぐにここで一覧を確認できます",
                    "files": "ファイルがアップロードされるとすぐに、こちらで一覧を確認できます",
                    "groups": "グループが作成されるとすぐに、こちらで一覧を確認できるようになります",
                    "offlineLicenses": "オフラインライセンスが作成されると、すぐにここでリストを確認できるようになります",
                    "permissions": "ユーザーに権限が割り当てられると、すぐにここでリストを確認できるようになります",
                    "productCodes": "製品コードが作成され次第、こちらで一覧を確認できるようになります",
                    "roles": "ロールが作成されるとすぐに、こちらで一覧を確認できるようになります",
                    "tasks": "タスクが作成されるとすぐに、ここで一覧を確認できます",
                    "users": "ユーザーが追加されると、すぐにここで一覧を確認できます"
                },
                "title": {
                    "batches": "タスクグループテーブルは空です",
                    "changes": "変更履歴テーブルは空です",
                    "companies": "企業テーブルは空です",
                    "configurationChanges": "",
                    "desktopLicenses": "Desktopライセンスのテーブルは空です",
                    "devices": "デバイステーブルは空です",
                    "files": "ファイルテーブルは空です",
                    "groups": "グループテーブルは空です",
                    "offlineLicenses": "オフラインライセンステーブルは空です",
                    "permissions": "権限テーブルは空です",
                    "productCodes": "製品コードテーブルは空です",
                    "roles": "ロールテーブルは空です",
                    "tasks": "タスクテーブルは空です",
                    "users": "ユーザーテーブルは空です"
                }
            },
            "no permission": {
                "description": "アクセスをご希望の場合は、管理者にお問い合わせください。",
                "title": "このコンテンツを表示する権限がありません"
            },
            "no results found": {
                "description": "別のキーワードやフィルターを試して結果を取得してください",
                "title": "検索結果が見つかりませんでした"
            },
            "button": {
                "add": {
                    "companies": "会社を作成する",
                    "devices": "デバイスを追加",
                    "files": "ファイルをアップロード",
                    "groups": "グループを作成する",
                    "productCodes": "製品コードを追加",
                    "tasks": "タスクを作成する",
                    "users": "ユーザーを招待する"
                },
                "reset view": "表示をリセット"
            }
        },
        "exausted autoscan limit": "自動スキャン制限に達するまで",
        "exausted vin parsing limit": "VIN解析の制限に達するまで",
        "expiration": "有効期限",
        "expiration date": "有効期限",
        "expires at": "有効期限：",
        "expiry date": "有効期限",
        "field": "フィールド",
        "file": "ファイル",
        "file id": "ファイルID",
        "files": "ファイル",
        "file type": "ファイルタイプ",
        "filter by": "フィルター",
        "firmware": "ファームウェア",
        "general": "一般",
        "general data": "一般データ",
        "gnss version": "GNSSバージョン",
        "group": "グループ",
        "groups": "デバイスグループ",
        "group vip status": "",
        "gsm number": "GSM番号",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "<1>FMxプラットフォーム</1> - FMx（FMB、FMU、FMC、FMM）、FMT、FMP、TAT、MSP、TFT、TST、GH（GH5200）、およびTMTモデル。",
                "ft platform": "<1>FTプラットフォーム</1> - FTxモデルとATxモデル。",
                "legacy platform": "<1>レガシープラットフォーム</1> - FM（FM4001およびFM3010を除く）、FMA、およびGH（GH4000）モデル。",
                "title": "テレマティクスデバイスのプラットフォーム生成"
            },
            "visibility": "<1>内部</1>とラベル付けされた変更はクライアントには表示されません。<2>デバイスの変更には可視データと非可視データの両方が含まれる可能性があるため、<1>外部コミュニケーションにおいてスクリーンショットや詳細情報を共有しないでください</1>。"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "情報",
        "interface": "インターフェース",
        "invited by": "招待により",
        "items": "アイテム",
        "last checked at": "最終確認日時：",
        "last sign in": "最終ログイン",
        "last status update": "最終ステータス更新",
        "last used at": "最後に使用されたのは",
        "license disabled": "無効化",
        "license enabled": "有効化済み",
        "license key": "ライセンスキー",
        "license name": "",
        "links": "リンク",
        "manual_geofence_scenarios": "手動ジオフェンスシナリオ",
        "message": "メッセージ",
        "model": "モデル",
        "model task type support": {
            "false": "非対応",
            "true": "対応"
        },
        "modem version": "モデム版",
        "name": "名称",
        "new value": "新しい値",
        "next task": "次のタスク",
        "no changes": "変更なし。",
        "no company name": "会社名なし",
        "no details": "詳細なし",
        "no file": "ファイルなし",
        "no imei available": "IMEIは利用不可",
        "no model": "モデルなし",
        "no parent company": "親会社なし",
        "no tasks": "デバイスにはタスクがありません。",
        "number": "番号",
        "obd": "OBD",
        "obd chip firmware version": "OBDチップファームウェアバージョン",
        "of": "の",
        "offline licenses tab disabled": "無効化されたdesktopライセンスに対しては、オフラインライセンスは利用できません。",
        "origin": "",
        "original value": "元の値",
        "other information": "その他の情報",
        "page of": "ページ",
        "parent company": "親会社",
        "permission count": "許可数",
        "platform": "プラットフォーム",
        "Price": "価格",
        "product code": "製品コード",
        "program number": "プログラム番号",
        "property": "プロパティ",
        "queue": "キュー",
        "receiving company": "受取会社",
        "revision": "改訂版",
        "role": "役割",
        "role name": "ロール名",
        "rows per page": "1ページあたりの行数",
        "running": "稼働中",
        "schedule": "スケジュール",
        "seen at": "最終確認日時",
        "select row": "行を選択して詳細を表示",
        "send sms": "SMS送信",
        "serial": "シリアル番号",
        "show details": {
            "desktopLicenses": "Desktopライセンスの詳細を表示",
            "devices": "デバイス詳細を表示",
            "batches": "タスクグループの詳細を表示",
            "tasks": "タスクの詳細を表示",
            "companies": "会社詳細を表示"
        },
        "sim": "SIM",
        "size": "サイズ",
        "software date": "ソフトウェア日付",
        "source company": "ソース企業",
        "spec_id": "Spec ID",
        "status": "ステータス",
        "status id": "ステータスID",
        "status name": "ステータス名",
        "supported task types": "サポートされるタスクの種類",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "テーブルの列",
        "target company": "対象企業",
        "task id": "タスクID",
        "task queue": "タスクキュー",
        "tasks": "タスク",
        "task type": "タスクタイプ",
        "tct web support": "TCT webサポート",
        "total": "トータル",
        "type": "タイプ",
        "updated at": "更新日時：",
        "updated by": "更新者：",
        "unknown": "不明",
        "user cannot be deleted": "ユーザーを削除することはできません。",
        "user cannot be edited": "ユーザーは編集できません。",
        "user cannot delete himself": "ユーザーは自身のプロフィールを削除できません。",
        "user date statuses": {
            "expired": "期限切れ",
            "expires": "期限切れ",
            "never expires": "有効期限なし",
            "sent": "送信"
        },
        "user email": "ユーザーメールアドレス",
        "user invitation cannot be cancelled": "ユーザー招待はキャンセルできません。",
        "user invitation cannot be resent": "ユーザー招待の再送信はできません。",
        "user sent configuration": "",
        "user statuses": {
            "Active": "アクティブ",
            "Inactive": "非アクティブ",
            "InvitationExpired": "期限切れの招待",
            "InvitationPending": "招待待ち"
        },
        "users": "ユーザー",
        "value from": "値（開始）",
        "value to": "値（終了）",
        "view all roles": "すべて表示 ({{count}})",
        "vin": "VIN",
        "vip status": "VIPステータス",
        "visibility": "可視性"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "権限情報",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "アクセサリインターフェースの名称。",
                    "type": "接続されたアクセサリタイプ。"
                },
                "can": {
                    "assigned package": "デバイスに割り当てられたOEMパッケージ。",
                    "can oem file package": "前回の接続時に報告されたOEMパッケージ。",
                    "can oem file vehicle": "最終接続時に報告されたOEM車両構成。",
                    "dtb": "",
                    "firmware": "CANファームウェアのバージョン。"
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "最新の受信CANアダプタ起動文字列（現在のデータとアダプタのプログラム番号を含む）。",
                    "program number": "CANアダプターのプログラム番号。",
                    "revision": "",
                    "software date": "CANアダプターのソフトウェア日付。",
                    "type": "CANアダプタの種類。"
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "最後に送信された1-Wire認証リストファイル名。",
                    "bluetooth_authorization": "最後に送信されたBluetooth認証リストのファイル名。",
                    "main configuration": "最後に送信されたメイン設定ファイル名。",
                    "manual_geofence_scenarios": "最後に送信された手動ジオフェンスリストのファイル名。"
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "最終接続時に報告されたBLEファームウェアのバージョン。",
                    "bluetooth password": "",
                    "bootloader": "最終接続時に報告されたデバイスのブートローダーのバージョン。",
                    "company": "このデバイスを所有する企業。",
                    "configuration": "最後に送信された設定ファイル名。",
                    "description": "デバイス説明（ユーザー定義）。",
                    "dtb": "最終接続時に報告されたデバイスツリーブロブのバージョン。",
                    "firmware": "最終接続時に報告されたデバイスファームウェアのバージョン。",
                    "gnss version": "最終接続時に報告されたGNSSのバージョン。",
                    "group": "このデバイスが割り当てられているデバイスグループ。",
                    "product code": "デバイスの製品コード。",
                    "serial": "デバイスのシリアル番号。"
                },
                "obd": {
                    "obd chip firmware version": "最終接続時に報告されたOBDチップファームウェアのバージョン。",
                    "vin": "特定の自動車を識別する固有の17桁のコード。"
                },
                "sim": {
                    "gsm number": "デバイスに関連付けられた公衆電話番号。",
                    "iccid": "SIMカードを識別する固有のシリアル番号。",
                    "imsi": "モバイルネットワーク加入者固有識別子。"
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "ユーザー作成日時。",
                    "id": "ユーザー固有のID。",
                    "invited by": "招待を作成したユーザーのメールアドレス。",
                    "role": "ユーザーに割り当てられた役割。",
                    "updated at": "最終ユーザー更新日時。"
                }
            }
        },
        "user details": "ユーザー詳細"
    },
    "Task groups": {
        "all": "すべて",
        "bulk type": {
            "CompanyBulkDelete": "会社削除",
            "DeviceBulkCreate": "デバイスを追加",
            "DeviceBulkDelete": "デバイスを削除",
            "DeviceBulkUpdate": "デバイスの更新",
            "FileBulkDelete": "ファイルを削除",
            "GroupBulkDelete": "グループを削除",
            "TaskBulkCreate": "タスクを作成する",
            "TaskBulkUpdate": "タスクをキャンセル",
            "UserBulkDelete": "ユーザーを削除"
        },
        "pending approval": "承認待ち",
        "already approved": "承認済み",
        "no approval required": "承認不要",
        "total objects": "総オブジェクト数",
        "total tasks": "総タスク数"
    },
    "Task status": {
        "0": "保留中",
        "1": "稼働中",
        "2": "完了",
        "3": "エラーを伴って完了しました",
        "4": "キャンセルされました",
        "5": "失敗",
        "6": "期限切れ",
        "7": "承認待ち",
        "8": "検証中",
        "task count": {
            "0": "保留中のタスク",
            "1": "実行中のタスク",
            "3": "エラーのあるタスクを完了",
            "5": "失敗したタスク"
        },
        "verified tooltip title": "タスクは正常に完了し、デバイスによって確認されました。"
    },
    "Tasks": {
        "0": "タスクはキューに追加され、現在待機中です。",
        "1": "タスクは現在実行中です。",
        "2": "タスクは正常に完了しました。",
        "3": "タスクは完了しましたが、いくつかのエラーが発生しました。",
        "4": "タスクはキャンセルされました。",
        "5": "タスクは失敗しました。",
        "6": "タスクは所定の時間枠内に完了しませんでした。"
    },
    "Tct": {
        "edit configuration": "設定を編集する",
        "no editable configurations": "編集可能な設定はアップロードされません",
        "open tct": "Open TCT web版",
        "open tct description": "TCT web版で新規設定を作成するか、FOTA WEBから既存の設定ファイルを編集するかを選択してください。",
        "select configuration file": "TCT webで編集したい設定ファイルを選択してください。",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web版はプレミアム企業レベルでのみ利用可能です。"
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
